import { Component, OnInit, Input, HostListener } from '@angular/core';
import { Location } from '@angular/common';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Router, ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import * as moment from 'moment-timezone';
import { saveAs } from 'file-saver';
import { HttpService } from 'app/shared/services/http.service';
import { SharedService } from 'app/shared/services/shared.service';
import { GridService } from 'app/shared/services/grid.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { ReportsService } from 'app/shared/services/reports.service';
import { ModalsService } from 'app/shared/services/modals.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';
import { UserService } from 'app/shared/services/user.service';
import { DemandService } from 'app/shared/services/demand.service';
import { SupplyService } from 'app/shared/services/supply.service';

@AutoUnsubscribe()
@Component({
  selector: 'report-component',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss'],
})
export class ReportComponent implements OnInit {
  // Properties
  @Input() public title: string;
  @Input() public reportType: string;
  @Input() public reportLink: string;
  @Input() public injectedDimensions: Array<any>;
  @Input() labsVer: number;
  @Input() tabsData: Array<any>;
  public queryParams: any;
  public data: Array<any>;
  public dataTotal: Array<any>;
  public columnsSettings: Array<any>;
  public reportColumnsAlias: Array<string>;
  public adminMode: boolean;
  public dimensions: Array<any>;
  public pseudoDimensions: Array<any>;
  public endpointURL: string;
  public isLoading: boolean;
  public isError: boolean;
  public isExporting: boolean;
  public displayGrid: boolean;
  public isReportChanged: boolean;
  public isTotalGraph: boolean;
  public isAggregatedGraph: boolean;
  public graphTotals: Array<any>;
  public selectedDimensions: Array<any>;
  public selectedDimensionsData: Array<any>;
  public fetchedReportDimensions: string;
  public fetchedReportMultifilters: any;
  public lastReportDimensions: string;
  public lastReportMultifilters: any;
  public showDimensionsList: boolean;
  public draggedDimensionIndex: number;
  public startDate: Date;
  public endDate: Date;
  public datesRange: any = {};
  public multifilters: any;
  public sorting: any;
  public filters: any;
  public filtersForGrid: any;
  public measuresArr: any;
  public getReportObservable: any;
  public searchDimensionObservable: any;
  public searchDimensionIDs: Array<number>;
  public searchDimensionTimeout: any;
  public availableMultifilters: any;
  public selectedMultifilters: any;
  public multifiltersSearch: string;
  public multifiltersLoadingState: any;
  public isBigReport: boolean;
  public primaryKeys: Array<string>;
  public graphItemsData: Array<any>;
  public graphProperties: Array<any>;
  public graphWidth: number;
  public graphHeight: number;
  public graphPoints: Array<any>;
  public graphXPoints: Array<any>;
  public graphYPoints: Array<any>;
  public graphMaxPoint: number;
  public graphXOffset: number;
  public graphYOffset: number;
  public graphFloorY: number;
  public graphScalesNum: number;
  public graphCurrKey: string;
  public graphToggleStatus: boolean;
  public graphUpdateDelay: number;
  public graphFullScreenState: boolean;
  public graphs: any;
  public selectedCountry: string;
  public countries: string[];

  public selectedItems: Array<any>;
  public timezoneLabel: string;
  public subscriptions: Array<any>;
  public isReportTimeout: boolean;
  public reportTimeout: any;
  public reportTimeoutTime: number;
  public goButtonState: boolean;
  public cancelButtonState: boolean;
  public userChangedSorting: boolean;
  public isDemandReport: boolean;
  public showDemandStatus: boolean;
  public isColumnsLoaded: boolean;
  public reportFetching: boolean;
  public showGraphButtons: boolean;
  public defaultReportsArr: Array<any>;
  public theSameCustomReport: boolean;
  public tabIndexSelected: number;
  public showPartnerReport: boolean;
  graphDimension: string;

  // Constructor
  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public httpService: HttpService,
    public sharedService: SharedService,
    public gridService: GridService,
    public dictionaryService: DictionaryService,
    public reportsService: ReportsService,
    public userService: UserService,
    public modalsService: ModalsService,
    public ga: GoogleAnalyticsService,
    public demandService: DemandService,
    public supplyService: SupplyService,
    public location: Location
  ) {
    this.labsVer = this.userService.getFeatureState('events_v2_results')
      ? 2
      : this.userService.isCedatoPublisher()
      ? 2
      : 1;
    this.title = '';
    this.reportLink = '';
    this.reportType = '';
    this.graphs =  {
      days: {
        isLoading: false,
        graphLoadErrorsCount: 0,
        data: [],
      },
      countries: {
        isLoading: false,
        graphLoadErrorsCount: 0,
        data: [],
      }
    };
    this.countries = [];
    this.selectedCountry = '';
    this.queryParams = {};
    this.data = [];
    this.dataTotal = [];
    this.tabsData =
      this.userService.getFeatureState('publisher_hb') &&
      this.userService.userData.publisher_reportType &&
      +this.userService.userData.publisher_reportType === 3
        ? [
            { title: this.dictionaryService.get('OUTSTREAM'), key: 'out' },
            { title: this.dictionaryService.get('INSTREAM'), key: 'in' },
          ]
        : [];
    this.columnsSettings = [];
    this.reportColumnsAlias = [];
    this.adminMode = false;
    this.dimensions =
      this.labsVer === 2
        ? _.sortBy(_.cloneDeep(this.reportsService['dimensions_v2']), 'name')
        : _.sortBy(_.cloneDeep(this.reportsService['dimensions_v1']), 'name');
    this.pseudoDimensions = [];
    this.endpointURL = 'dynamic_reports';
    this.isLoading = false;
    this.isError = false;
    this.isExporting = false;
    this.isReportChanged = false;
    this.isBigReport = false;
    this.isTotalGraph = true;
    this.isAggregatedGraph = true;
    this.displayGrid = +this.route.snapshot.queryParams.crp === 1;
    this.graphTotals = [];
    this.injectedDimensions = [];
    this.selectedDimensions = [];
    this.selectedDimensionsData = [];
    this.lastReportDimensions = '';
    this.lastReportMultifilters = [];
    this.fetchedReportDimensions = '';
    this.fetchedReportMultifilters = [];
    this.showDimensionsList = false;
    this.draggedDimensionIndex = null;
    this.startDate = new Date();
    this.endDate = new Date();
    this.multifilters = {};
    this.sorting = {};
    this.filters = {};
    this.filtersForGrid = {};
    this.searchDimensionIDs = [];
    this.availableMultifilters = {};
    this.selectedMultifilters = {};
    this.multifiltersSearch = '';
    this.multifiltersLoadingState = {};
    this.primaryKeys = [];
    this.measuresArr = [];
    this.graphProperties = [];
    this.graphWidth = 0;
    this.graphHeight = 192;
    this.graphPoints = [];
    this.graphXOffset = 24;
    this.graphYOffset = 24;
    this.graphFloorY = this.graphHeight - this.graphYOffset;
    this.graphScalesNum = 2;
    this.graphItemsData = [];
    this.graphCurrKey = '';
    this.graphToggleStatus = true;
    this.graphUpdateDelay = 400;
    this.graphFullScreenState = false;
    this.selectedItems = [];
    this.subscriptions = [];
    this.isReportTimeout = false;
    this.reportTimeoutTime = 30000;
    this.cancelButtonState = !this.sharedService.isEmpty(this.route.snapshot.queryParams.from);
    this.userChangedSorting = false;
    this.isDemandReport = false;
    this.showDemandStatus = false;
    this.isColumnsLoaded = false;
    this.reportFetching = false;
    this.showGraphButtons = true;
    this.defaultReportsArr = [];
    this.theSameCustomReport = false;
    this.tabIndexSelected = 0;
    this.graphDimension = '';
  }

  ngOnDestroy() {
    this.resetState();
  }

  // On initialization
  ngOnInit() {
    // Graph state
    if (!this.sharedService.isEmpty(localStorage.getItem('graphToggleStatus'))) {
      this.graphToggleStatus = localStorage.getItem('graphToggleStatus') === 'true';
    } else {
      localStorage.setItem('graphToggleStatus', this.graphToggleStatus.toString());
    }

    // Messages bus
    this.subscriptions.push(
      this.sharedService.getMessagesBus().subscribe((response: any) => {
        if (response.type === 'NETWORK_CHANGE') {
          this.onNetworkChange(response.data);
        } else if (response.type === 'TIMEZONE_CHANGE') {
          this.onTimezoneChange();
        } else if (response.type === 'GRID_VALUE_CHANGE') {
          this.onItemSelectChange(response.data);
        } else if (response.type === 'GRID_SELECTION_CHANGE') {
          this.onSelectAllChange(response.data);
        } else if (response.type === 'REPORT_BY_EMAIL') {
          this.onReportShouldGoByEmail(response.data);
        }
      })
    );

    // Reset the selected items
    this.selectedItems = [];
    this.defaultReportsArr = this.reportsService.narrowDefaultReports();

    this.subscriptions.push(
      this.route.data.subscribe((data: any) => {
        this.adminMode = data && data.isAdmin;
        if (this.adminMode) { this.endpointURL = 'admin_dynamic_reports'; }

        this.labsVer = data.labsVer ? +data.labsVer : this.labsVer;

        this.reportType = data.reportType ? data.reportType : '';

        this.gridService.buildReportColumns(this.labsVer);
        this.gridService.buildColumnsDefaults(this.labsVer);
        this.dimensions = this.adminMode
          ? _.cloneDeep(this.reportsService['adminDimensions_v' + this.labsVer])
          : _.sortBy(_.cloneDeep(this.reportsService['dimensions_v' + this.labsVer]), 'name');

        this.pseudoDimensions = this.adminMode
          ? _.cloneDeep(this.reportsService['adminPseudoDimensions_v' + this.labsVer])
          : _.sortBy(_.cloneDeep(this.reportsService['pseudoDimensions_v' + this.labsVer]), 'name');

        if (this.reportType === 'content_reports') {
          this.dimensions = _.remove(this.dimensions, (one) => {
            return one.name.toLowerCase().indexOf('demand') === -1;
          });
          this.pseudoDimensions = _.remove(this.pseudoDimensions, (one) => {
            return one.name.toLowerCase().indexOf('demand') === -1;
          });
        } else {
          this.dimensions = _.remove(this.dimensions, (one) => {
            const name = one.name.toLowerCase();
            return name.indexOf('content') === -1 || name.indexOf('utm') !== -1;
          });
          this.pseudoDimensions = _.remove(this.pseudoDimensions, (one) => {
            return one.name.toLowerCase().indexOf('content') === -1;
          });
        }

        if (data.injectedDimensions && data.injectedDimensions.length) {
          this.injectedDimensions = data.injectedDimensions;
          this.parseInjectedDimensions();
        }
      })
    );

    // Query parameters
    this.subscriptions.push(
      this.route.queryParams.subscribe((params: any) => {
        this.queryParams = _.cloneDeep(params);

        if (this.reportType === 'exco-player-release' && !this.queryParams.d) {
          this.router.navigate([], { queryParams: { ...this.queryParams, d: 111 } }); // Sub ID 4(player version) dimension
        }
        this.parseQueryParams();
        if (this.queryParams.d === undefined) {
          this.parseInjectedDimensions();
        }
      })
    );

    this.sharedService.sendMessage('DATE_RANGE_CHANGE', {
      startDate: this.startDate,
      endDate: this.endDate,
    });
    // Timezone label
    this.updateTimezoneLabel();
    // Dates range
    this.updateDatesRange();
    this.fillLocalMultifilters();
    this.reportsService.isReportSentByEmail = false;
  }

  // On network change
  onNetworkChange(data: any) {
    const queryParams: any = _.cloneDeep(this.queryParams);
    queryParams.nid = data.networkId;

    if (queryParams.sqp == 1) {
      this.sharedService.saveQueryParamsOnNetworkChange = true;
      delete queryParams.sqp;
    }

    if (!this.sharedService.saveQueryParamsOnNetworkChange) {
      delete queryParams.d;
      delete queryParams.s;
      delete queryParams.f;
    } else {
      this.sharedService.saveQueryParamsOnNetworkChange = false;
    }

    if (!data.forcedChange) {
      this.resetReportSettings();
      this.router.navigate([this.userService.getDefaultRoute()], { queryParams: queryParams }).then(() => {
        return;
      });
    }
  }

  // On timezone change
  onTimezoneChange() {
    this.updateTimezoneLabel();
    this.resetReportSettings(false);
    this.onGoButtonClick();
  }

  // Update timezone label
  updateTimezoneLabel() {
    this.timezoneLabel =
      this.reportsService.selectedTimezone.name + ' ' + this.reportsService.getTimezoneOffset(null, false);
  }

  // Get report title
  getTitle(fixCase: boolean = false) {
    let title = '';
    let customReport: any;
    let reportId: number;
    let currDefaultReport: any;
    if (this.title) {
      title = this.title;
      currDefaultReport = _.find(this.defaultReportsArr, { link: location.pathname });
      if (currDefaultReport) {
        title = this.dictionaryService.get(currDefaultReport.name).toUpperCase();
      }
      if (fixCase) {
        title = this.sharedService.fixCase(title);
      }
    } else if (_.find(this.defaultReportsArr, { link: location.pathname })) {
      currDefaultReport = _.find(this.defaultReportsArr, { link: location.pathname });
      title = this.dictionaryService.get(currDefaultReport.name).toUpperCase();

      if (fixCase) { title = this.sharedService.fixCase(title); }
    } else if (this.queryParams.id) {
      reportId = parseInt(this.queryParams.id);
      customReport = _.find(this.reportsService.customReports, { reportId: reportId.toString() });
      if (customReport) {
        title = customReport.name;
      }
    }

    if (this.sharedService.isEmpty(title)) {

      switch (this.reportType) {
        case 'exco-player-release':
          title = this.dictionaryService.get('RELEASE_DASHBOARD');
          break;
        case 'exco':
          title = this.dictionaryService.get('EXCO_REPORT');
          break;
        case 'network':
          title = this.dictionaryService.get('NETWORKS_REPORT');
          break;
        default:
          title = this.adminMode
            ? this.dictionaryService.get('CUSTOM_REPORT_ADMIN')
            : this.dictionaryService.get('CUSTOM_REPORT');
          break;
      }
      if (this.labsVer > 1 && this.adminMode && this.reportType !== 'exco-player-release') { title += ' V' + this.labsVer; }
    }

    return title;
  }

  // Parse injected dimensions
  parseInjectedDimensions() {
    let currDimension: any;
    const beforeInjected: number = this.selectedDimensions.length;
    if (this.injectedDimensions.length > 0) {
      for (let i = 0; i < this.injectedDimensions.length; i++) {
        currDimension = _.find(this.dimensions, { dimension_id: this.injectedDimensions[i].toString() });
        if (currDimension) {
          if (this.selectedDimensions.indexOf(currDimension) === -1) {
            this.toggleSelectDimension(currDimension, true);
          }
        }
      }
      if (this.selectedDimensions.length !== beforeInjected) {
        this.onGoButtonClick();
      }
    }
  }

  resetState() {
    // Delete old requests
    if (this.getReportObservable) {
      this.getReportObservable.unsubscribe();
    }
    this.isLoading = false;
    clearTimeout(this.reportTimeout);
    this.isReportTimeout = false;

    Object.values(this.graphs).forEach((state: any) => {
      if (state.getGraphSubscription) {
        state.getGraphSubscription.unsubscribe();
      }
      state.isLoading = false;
    });
  }

  hasLoadingGraph() {
    return Object.values(this.graphs).some((state: any) => state.isLoading);
  }

  // Parse query params
  parseQueryParams() {
    let savedDates: any;
    if (!this.sharedService.isEmpty(localStorage.getItem('selectedDates'))) {
      savedDates = JSON.parse(localStorage.getItem('selectedDates'));
    }

    const startDate: Date = this.queryParams.sd
      ? moment(this.queryParams.sd).toDate()
      : savedDates && !this.sharedService.isEmpty(savedDates.startDate)
      ? new Date(savedDates.startDate)
      : new Date();
    const endDate: Date = this.queryParams.ed
      ? moment(this.queryParams.ed).toDate()
      : savedDates && !this.sharedService.isEmpty(savedDates.endDate)
      ? new Date(savedDates.endDate)
      : new Date();

    let dimensions: Array<any>;
    let currReportId: number;
    let currCustomReport: any;
    let currDefaultReport: any;
    let currCustomQueryParams: any;
    let currDimension: any;
    let currDimensionId: any;
    let currMultifilter: any;
    let currSorting: any;
    let currFilter: any;
    let currKey: string;
    let currValue: string;
    let currKeyVal: Array<any>;
    let timezoneName: string;
    let network: any;
    let thisRouterURL: any;

    if (this.router && this.router.url) {
      thisRouterURL = this.router.url.split('?')[0];
      if (thisRouterURL.length) { thisRouterURL = thisRouterURL.replace(/^\//g, ''); }
    }

    this.resetState();

    // Set timezone
    if (this.queryParams.tz) {
      timezoneName = this.queryParams.tz.replace('--', '/');
      if (_.find(this.reportsService.timezones, { key: timezoneName })) {
        this.reportsService.setTimezone(timezoneName, true);
      }
    }

    // Set selected tab
    if (this.queryParams.tab) {
      if (this.tabsData.length >= +this.queryParams.tab) {
        this.tabIndexSelected = +this.queryParams.tab;
      }
    }

    // Start and End Date
    if (startDate && endDate && startDate.getTime() <= endDate.getTime()) {
      // Start date
      if (this.reportsService.isValidDate(startDate, true)) {
        this.startDate = startDate;
      }
      // End date
      if (this.reportsService.isValidDate(endDate, true)) {
        this.endDate = endDate;
      }
    } else {
      this.startDate = new Date();
      this.endDate = new Date();
    }
    this.updateDatesRange();

    // Network id
    if (this.queryParams.nid) {
      // If this is an admin user
      if (this.userService.isAdmin()) {
        // Find the relevant network
        network = _.find(this.sharedService.activeNetworks, { networkId: this.queryParams.nid });
        // If the network exists...
        if (network) {
          // If the query params network ID is not the current network ID...
          if (network.networkId.toString() !== this.userService.networkData.networkId.toString()) {
            // Change the network, and once it's finished, parse the query params again (will just get the report this time)
            this.userService.changeNetwork(network, true).subscribe(() => {
              this.parseQueryParams();
            });
            // Prevent the report from being fetched, as we first of all want to switch to the new network
            return;
          }
        }
      } else {
        // Delete the parameter
        delete this.queryParams.nid;
        // Reroute to the same URL, without the network ID parameter
        this.router.navigate([], { queryParams: this.queryParams }).then(() => {
          return;
        });
        // Prevent the report from being fetched, as we first of all want to delete the 'nid' parameter
        return;
      }
    }
    // Report ID
    if (this.queryParams.id) {
      currReportId = parseInt(this.queryParams.id);
      currCustomReport = _.find(this.reportsService.customReports, (report: any) => {
        return parseInt(report.reportId) === currReportId;
      });
      if (currCustomReport) {
        if (
          currCustomReport.dimensions === this.queryParams.d &&
          (currCustomReport.filters === this.queryParams.f ||
            (this.sharedService.isEmpty(currCustomReport.filters) && this.sharedService.isEmpty(this.queryParams.f))) &&
          (currCustomReport.sorting === this.queryParams.s ||
            (this.sharedService.isEmpty(currCustomReport.sorting) && this.sharedService.isEmpty(this.queryParams.s)))
        ) {
          currCustomQueryParams = _.cloneDeep(this.queryParams);
          if (!this.queryParams.d) {
            currCustomQueryParams.d = currCustomReport.dimensions;
          }
          if (!this.queryParams.f && currCustomQueryParams.filters) {
            currCustomQueryParams.f = currCustomReport.filters;
          }
          if (!this.queryParams.s && currCustomQueryParams.sorting) {
            currCustomQueryParams.s = currCustomReport.sorting;
          }
          if (currCustomQueryParams.link) {
            this.reportLink = currCustomReport.link;
          }
        }
      }
    }

    // Dimensions and multifilters
    this.selectedDimensions = [];
    this.multifilters = {};
    if (this.queryParams.d) {
      dimensions = this.queryParams.d.split('--');
      for (let i = 0; i < dimensions.length; i++) {
        currDimensionId = parseInt(dimensions[i].split('=')[0]);
        currMultifilter = dimensions[i].split('=')[1];
        currDimension = _.find(this.dimensions, (dimension: any) => {
          return +dimension.dimension_id === currDimensionId;
        });
        if (currDimension) {
          this.toggleSelectDimension(currDimension, true);
          if (currMultifilter !== undefined) {
            currMultifilter = currMultifilter.replace(/,\s/g, '%!%').split(',');
            for (let j = 0; j < currMultifilter.length; j++) {
              this.toggleMultifilter(currDimension, currMultifilter[j].replace(/%!%/g, ', '));
            }
          }
        }
      }
    }

    // Demand status
    this.isDemandReport = this.isItDemandReport();
    if (this.queryParams.ds) {
      if (this.isDemandReport) {
        this.showDemandStatus = +this.queryParams.ds === 1;
      } else {
        delete this.queryParams.ds;
        this.onGoButtonClick(true, true);
      }
    }

    //Redirect to correct report URL
    if (!this.adminMode) {
      // 1. If it's Custom saved Report
      if (currCustomReport && currCustomReport.link) {
        if (decodeURI(thisRouterURL) !== decodeURI(currCustomReport.link.replace(/^\//g, ''))) {
          this.router
            .navigate([currCustomReport.link], {
              queryParams: {
                ...this.queryParams,
                from: currCustomReport.id,
              },
            })
            .then(() => {
              return;
            });
        }
      } else {
        // 2. If it's One of Default Reports
        currDefaultReport = _.filter(this.defaultReportsArr, (one: any) => {
          if (
            _.isEqual(
              one.d,
              _.map(this.selectedDimensions, (two: any) => +two.dimension_id)
            )
          ) {
            return one;
          }
        });

        if (this.reportType !== 'content_reports') {
          if (
            currDefaultReport.length &&
            !_.isEqual(
              _.map(currDefaultReport.d, (d: any) => d.toString()),
              _.map(this.selectedDimensions, 'dimension_id')
            )
          ) {
            if (decodeURI(thisRouterURL) !== decodeURI(currDefaultReport[0]['link'].replace(/^\/|\/$/g, ''))) {
              this.router
                .navigate([currDefaultReport[0]['link']], {
                  queryParams: {
                    ...this.queryParams,
                    from: currDefaultReport.id,
                  },
                })
                .then(() => {
                  return;
                });
              return;
            }
          } else {
            this.router
              .navigate(['/reports/new'], { queryParams: { ...this.queryParams, from: currDefaultReport.id } })
              .then(() => {
                return;
              });
          }
        }
      }
    }

    // If there are any selected dimensions...
    if (this.selectedDimensions.length > 0) {
      // Getting the columns in different request.
      this.getColumns().then(() => {
        //!! Only we get exact list of report columns
        // we can validate Sorting and Filtering
        // Sorting
        this.sorting = {};
        if (this.queryParams.s) {
          currSorting = this.queryParams.s.split(',');
          if (this.reportColumnsAlias.includes(currSorting[0])) {
            this.sorting = {
              attrName: currSorting[0],
              sort: currSorting[1],
            };
          } else {
            this.sorting = this.setDefaultSorting();
            this.queryParams.s = this.sorting.attrName + ',' + this.sorting.sort;
            this.location.go(location.pathname, this.sharedService.stringToQueryParams(this.queryParams));
          }
        }

        // Filters
        this.filters = {};
        if (this.queryParams.f) {
          currFilter = this.queryParams.f.split('--');
          for (let i = 0; i < currFilter.length; i++) {
            currKey = currFilter[i].split('=')[0];
            currValue = currFilter[i].split('=')[1];
            if (
              this.reportColumnsAlias.includes(currKey) &&
              _.find(this.gridService.reportColumns, { reportKey: currKey })
            ) {
              if (_.find(this.gridService.reportColumns, { reportKey: currKey })['aggregated']) {
                //this is measure, continue parse
                currKeyVal = currValue.split('-');
                _.forEach(currKeyVal, (onePair) => {
                  if (onePair.split('_')[1] && !_.isNaN(parseFloat(onePair.split('_')[1]))) {
                    if (!this.filters[currKey]) { this.filters[currKey] = {}; }

                    this.filters[currKey][onePair.split('_')[0]] = parseFloat(onePair.split('_')[1]);
                  }
                });
              } else {
                this.filters[currKey] = currValue;
              }
            }
          }
        }

        this.filtersForGrid = this.parseFiltersForGrid();

        this.sharedService.sendMessage('GRID_REDRAW');
        this.getReport();
        if (+this.labsVer > 1 && this.reportType !== 'exco-player-release') {
          this.buildGraphs();
        }
      });
      if (+this.labsVer === 1) {
        this.buildGraph();
      }
    } else {
      this.resetReportData();
    }

    // Page title
    this.title = this.getTitle();
    this.sharedService.setPageTitle('REPORT', this.title);
  }

  // On 'Go' button click
  onGoButtonClick(userAction: boolean = false, noRedirect: boolean = false, isSortChanged: boolean = false) {
    const queryParams: any = {};
    const dimensions: Array<any> = [];
    let multifilters: Array<any> = [];
    let sorting: any;
    const filters: Array<any> = [];
    const selectedDimensionsValues: Array<string> = _.map(this.selectedDimensions, 'value');
    let measuresArr: Array<string>;
    let includeFilter: boolean;
    const isDemandReport: boolean = _.uniq(
      _.compact(
        _.map(this.selectedDimensions, (one: any) => {
          return one.name.toLowerCase().indexOf('demand') > -1;
        })
      )
    )[0];
    measuresArr = _.compact(
      _.map(this.gridService.buildMeasureColumns(this.labsVer), (one: any) => {
        return (!isDemandReport && one.isSupply) || (isDemandReport && one.isDemand) ? one.reportKey : null;
      })
    );

    // ID
    if (this.queryParams.id) {
      queryParams.id = this.queryParams.id;
    }
    // Start and end date
    queryParams.sd = moment(this.startDate).format('YYYY-MM-DD').toString();
    queryParams.ed = moment(this.endDate).format('YYYY-MM-DD').toString();
    // Dimensions and multifilters
    for (let i = 0; i < this.selectedDimensions.length; i++) {
      dimensions.push(this.selectedDimensions[i].dimension_id);
      multifilters = this.multifilters[this.selectedDimensions[i].value];
      if (multifilters) {
        if (multifilters.length > 0) {
          dimensions[i] = dimensions[i] + '=' + multifilters.join(',');
        }
      }
    }
    queryParams.d = dimensions.join('--');
    // Sorting
    sorting = this.setReportSorting(isSortChanged);
    queryParams.s = sorting.attrName + ',' + sorting.sort;
    // Filters
    for (const cell in this.filters) {
      includeFilter = false;
      // If the current filtered cell is a real dimension...
      if (_.find(this.dimensions, { value: cell })) {
        // ...then include it only if it's a part of the selected dimensions
        includeFilter = selectedDimensionsValues.includes(cell);
        // It's a pseudo-dimension, and we need to add it only if the associated dimension is selected
      } else if (_.find(this.pseudoDimensions, { value: cell })) {
        switch (cell) {
          case 'sn':
          case 'sm':
            includeFilter = selectedDimensionsValues.includes('si');
            break;
          case 'dn':
          case 'du':
            includeFilter = selectedDimensionsValues.includes('di');
            break;
          case 'cs':
            includeFilter = this.showDemandStatus;
            break;
        }
      } else if (measuresArr.includes(cell)) {
        includeFilter = measuresArr.includes(cell);
      }
      // If this filter should be included, add it; else, delete it.
      !includeFilter
        ? delete this.filters[cell]
        : typeof this.filters[cell] === 'string' || typeof this.filters[cell] === 'number'
        ? filters.push(cell + '=' + this.filters[cell])
        : _.isPlainObject(this.filters[cell]) && !this.sharedService.isEmptyObj(this.filters[cell])
        ? filters.push(cell + '=' + _.map(this.filters[cell], (v, k) => k + '_' + v).join('-'))
        : delete this.filters[cell];
    }

    if (filters.length > 0) {
      queryParams.f = filters.join('--');
    }

    // Report Tab
    if (this.tabsData.length) {
      queryParams.tab = this.tabIndexSelected;
    }

    // Timezone
    if (this.reportsService.selectedTimezone) {
      queryParams.tz = this.reportsService.selectedTimezone.name.replace('/', '--');
    }

    // Is Demand Report
    if (this.isDemandReport) {
      queryParams.ds = this.showDemandStatus ? '1' : '0';
    }

    // Network ID (admins-only)
    if (this.userService.isAdmin()) {
      queryParams.nid = this.userService.networkData.networkId;
    }

    //store Hidden columns for current custom report
    queryParams.crp = 1;

    // Execute
    if (noRedirect) {
      const url = this.sharedService.stringToQueryParams(queryParams);
      this.location.go(location.pathname, url);
    } else {
      if (_.isEqual(queryParams, this.queryParams)) {
        this.parseQueryParams();
      } else {
        this.isAggregatedGraph = true;
        this.router.navigate([], { queryParams: queryParams }).then(() => {
          return;
        });
      }
      this.cancelButtonState = userAction;
    }
  }

  // On 'Cancel' button click
  onCancelButtonClick() {
    const queryParams: any = _.cloneDeep(this.queryParams);
    let previousReport: any;

    this.resetState();
    this.cancelButtonState = false;
    this.updateGoButtonState(true);
    if (this.queryParams.from) {
      previousReport = _.find(this.defaultReportsArr, { id: parseInt(this.queryParams.from) });
      if (previousReport) {
        delete queryParams.d;
        delete queryParams.from;
        this.router.navigate([previousReport.link], { queryParams: queryParams }).then(() => {
          return;
        });
      }
    } else {
      this.sharedService.back();
    }
  }

  // Reset the report data (data, total data and graph)
  resetReportData() {
    this.data = [];
    this.dataTotal = [];
    this.clearGraph();
    this.graphPoints = [];
    this.graphProperties = [];
  }

  // Reset the report settings (clear filters, multifilters and localStorage, and set it to an aggregated and total graph)
  resetReportSettings(clearActiveMultifilters: boolean = true) {
    this.isTotalGraph = true;
    this.isAggregatedGraph = true;
    this.availableMultifilters = {};
    this.searchDimensionIDs = [];
    if (clearActiveMultifilters) {
      this.multifilters = {};
    }
    this.resetState();
    if (this.searchDimensionObservable) {
      this.searchDimensionObservable.unsubscribe();
    }
  }

  // Get list of report columns first
  getColumns() {
    return new Promise((resolve, reject) => {
      this.isLoading = true;
      const columns: Array<any> = [{ key: '$$selected', label: '' }];
      let columnSettings: any;
      const reportParams: any = this.setReportParams('multifilters');
      const title: string = this.getTitle();
      let find: any = null;
      let isVisible = true;
      const customRTBColumnsSettings: any = JSON.parse(localStorage.getItem('rtbColumnsVisibility'));
      let storedReportSettings: any = JSON.parse(localStorage.getItem('customGridSettings'));
      storedReportSettings = storedReportSettings && storedReportSettings[title] ? storedReportSettings[title] : {};

      this.measuresArr = [];
      this.getReportObservable = this.httpService
        .post(this.endpointURL + '/getReportColumns', reportParams)
        .subscribe((response: any) => {
          let data: any = _.cloneDeep(response.data);

          // No data safety net
          if (response.data === undefined) {
            data = [];
            this.isError = true;
          }
          // For all of the first item's properties
          for (const key in data[0]) {
            this.reportColumnsAlias = Object.keys(data[0]);
            // Get the column's settings
            columnSettings = this.gridService.getReportColumnSettings(key);

            if (columnSettings.key) {
              isVisible = columnSettings.hasOwnProperty('visible')
                ? columnSettings.visible
                : columnSettings.hasOwnProperty('defaultVisibility')
                ? columnSettings.defaultVisibility
                : true;

              if (
                customRTBColumnsSettings &&
                !_.isEmpty(customRTBColumnsSettings, true) &&
                this.gridService.rtbColumns.includes(columnSettings.key)
              ) {
                isVisible = customRTBColumnsSettings.includes(columnSettings.key);
              }

              find = _.find(this.gridService.reportColumns, { actualKey: columnSettings.key });
              if (find.reportKey.length === 2) {
                find = null;
              }

              if (storedReportSettings && storedReportSettings.visibleColumns) {
                if (find && columnSettings.key.substr(0, 2) !== '$$') {
                  if (storedReportSettings.visibleColumns.includes(columnSettings.key)) {
                    this.measuresArr.push(find.reportKey);
                  }

                  isVisible = storedReportSettings.visibleColumns.includes(columnSettings.key);
                }
              } else {
                if (find && isVisible) {
                  this.measuresArr.push(find.reportKey);
                }
              }

              // Store the current property in the columns-settings array
              columns.push({
                key: columnSettings.key,
                label: columnSettings.label,
                width: columnSettings.width,
                visible: isVisible,
                hidecedatox: ReportComponent.isCedatoX(columnSettings.key),
                filterType: columnSettings.filterType,
                filterOptions: columnSettings.filterOptions,
                parseFunction: columnSettings.parseFunction,
                parseTooltipFunction: columnSettings.parseTooltipFunction,
                disableHide:
                  (columnSettings.key.substr(0, 2) !== '$$' &&
                    _.filter(this.columnsSettings, { disableHide: true }).length === 0) ||
                  columnSettings.key === 'supply_id' ||
                  columnSettings.key === 'demand_id',
              });
            }
          }

          // Display the grid
          if (this.showPartnerReport) {
            this.columnsSettings.splice(5, 0,
              { key: 'partner_demand_id', label: 'PARTNER_DEMAND_ID', width: 130, filterType: 'INPUT' },
              { key: 'partner_demand_name', label: 'PARTNER_DEMAND_NAME', width: 350, filterType: 'INPUT' });
          } else {
            this.columnsSettings = columns;
          }
          this.displayGrid = true;
          this.isColumnsLoaded = true;
          resolve();
        });
    });
  }

  // Get a report's data
  getReport() {
    const reportParams: any = this.setReportParams();
    if (_.isEmpty(reportParams)) { return; }

    let noResults = true;
    let columnSettings: any;
    let recentReport: any;
    this.fetchedReportDimensions = reportParams.dimensions;
    this.fetchedReportMultifilters = reportParams.multifilters;
    this.reportTimeout = setTimeout(() => {
      if (!this.isReportTimeout) {
        this.isReportTimeout = true;
        this.exportAllByEmail(true);
      }
    }, this.reportTimeoutTime);
    // If we're not currently loading another report, and there's at least one selected dimension
    if (this.selectedDimensions.length > 0) {
      // Set `isLoading` as true, to prevent any new reports from being fetched, until this one has completed
      this.isLoading = true;
      this.reportFetching = true;
      // Set `isError` as false, to prevent the error message from showing
      this.isError = false;
      // Post the request to get the report-data
      this.getReportObservable = this.httpService.post(this.endpointURL + '/getReport', reportParams).subscribe(
        (response: any) => {
          // Save the fetched data as `data`
          let data: any = _.cloneDeep(response.data);
          // No data safety net
          if (response.data === undefined) {
            data = [];
            this.isError = true;
          }
          //is it Demand Report
          this.isDemandReport = this.isItDemandReport();

          // Check if this is a "big" report
          this.isBigReport = data.length >= this.reportsService.queriesLimit;
          // Clear timeout-related data
          clearTimeout(this.reportTimeout);
          this.isReportTimeout = false;
          this.modalsService.hideModal();

          // If there are no errors...
          if (data.errors === undefined) {
            // If there's only one item...
            if (data.length === 1) {
              // For all of the only item's keys...
              for (const key in data[0]) {
                // If there's a value, it means that the fetched results are not empty - we can stop checking
                if (data[0][key] !== '' && data[0][key] !== undefined && data[0][key] !== null) {
                  noResults = false;
                  break;
                }
              }
              // If there was only one item, and all of its values were empty - it means there are no results
              if (noResults) {
                data = [];
              }
            } else {
              noResults = false;
            }

            // Fix all keys, and mark all items as selected (default behavior after the data has been fetched)
            data.forEach((item: any, index: number) => {
              for (const key in item) {
                columnSettings = this.gridService.getReportColumnSettings(key);
                if (columnSettings) {
                  item[columnSettings.key] = item[key];
                }
                if (item[key] !== item[columnSettings.key]) { delete item[key]; }
              }
              item.$$selected = true;
              item.$$uuid = index;
              item.$$supplyx = item['sx'] ? item['sx'] : 0;
              item.$$demandx = item['dx'] ? item['dx'] : 0;
            });
            // Pass the data to the grid
            this.data = _.cloneDeep(data);
            this.selectedItems = _.filter(data, '$$selected');
            this.updateGraphSettings();

            if (this.reportType === 'exco-player-release') {
              this.buildGraphs();
            }

            // If there are no results...
            if (noResults) {
              // Don't display the total row
              this.dataTotal = [];
              this.isLoading = false;
            } else {
              if (this.isBigReport) {
                this.getReportTotal();
              } else {
                this.updateTotalsRow();
                // Force changes detection
                this.sharedService.sendMessage('GRID_DETECT_CHANGES');
              }
              this.isLoading = false;
            }
          } else {
            this.resetReportData();
            this.isLoading = false;
            this.isError = true;
          }

          this.lastReportDimensions = this.fetchedReportDimensions;
          this.lastReportMultifilters = this.fetchedReportMultifilters;
          this.reportFetching = false;
          this.resetCurrentCustomReport();
          this.updateGoButtonState();
          this.cancelButtonState = false;
        },
        (error: any) => {
          clearTimeout(this.reportTimeout);
          this.isReportTimeout = false;
          this.modalsService.hideModal();
          this.isLoading = false;
          this.isError = true;
          this.reportFetching = false;
          this.updateGoButtonState();
          this.cancelButtonState = false;
          this.sharedService.sendMessage('GRID_DETECT_CHANGES');
        }
      );
      // Save the request in the subscriptions array
      this.subscriptions.push(this.getReportObservable);
      return this.getReportObservable;
    }

    // Save as a recent report
    if (!this.sharedService.isEmpty(this.reportLink)) {
      recentReport = {
        link: '/' + this.reportLink,
        name: this.title,
        queryParams: {},
      };
      if (this.queryParams.id) {
        recentReport.id = this.queryParams.id;
        recentReport.queryParams = _.cloneDeep(this.queryParams);
      }
      if (recentReport.queryParams.sd) {
        delete recentReport.queryParams.sd;
      }
      if (recentReport.queryParams.ed) {
        delete recentReport.queryParams.ed;
      }
      this.reportsService.updateRecentReports(recentReport);
    }
  }

  adaptChartData(chartType) {
    if (chartType === 'countries') {
      const allCountries = this.graphs.countries.data.map(item => item.co) || [];
      this.countries = _.uniq(allCountries);
      this.selectedCountry = this.countries[0];
    }
  }

  buildGraphs() {
    if (this.reportType === 'exco-player-release') {
      this.buildGraph('countries');
      // this.buildGraph('devices');  TODO: implement
      // this.buildGraph('os'); TODO: implement
    }
    this.buildGraph('days');
  }

  // Get the graph's data by time
  buildGraph(type = 'days') {
    const reportParams: any = this.setReportParams('graph');
    reportParams.dimensions += this.getDimensionByGraphType(type);
    this.graphs[type].isLoading = true;
    this.sharedService.sendMessage('GRID_DETECT_CHANGES');

    this.graphs[type].getGraphSubscription = this.httpService.post(this.endpointURL + '/getGraphData', reportParams).subscribe(
      (response: any) => {
        if (!reportParams.selected) {
          const graphParamsWithData: any = {
            networkId: this.userService.networkData.networkId,
            title: this.title,
            params: reportParams,
            data: response.data ? response.data : [],
          };

          if (type === 'days') {
            localStorage.setItem('currentGraphData', JSON.stringify(graphParamsWithData));
          }
        }
        if (type === 'days') {
          this.parseGraphData(response.data ? response.data : []);
        } else {
          this.graphs[type].data = response.data ? response.data : [];
          this.adaptChartData(type);
        }
        this.graphs[type].graphLoadErrorsCount = 0;
        this.graphs[type].isLoading = false;
      },
      (error: any) => {
        if (this.graphs[type].graphLoadErrorsCount < this.reportsService.graphMaxLoadFails) {
          this.graphs[type].graphLoadErrorsCount++;
          this.buildGraph(type);
        } else {
          this.graphs[type].isLoading = false;
          this.graphToggleStatus = false;
        }
      }
    );
    this.subscriptions.push(this.graphs[type].getGraphSubscription);
  }

  getDimensionByGraphType(type: string = 'countries') {
    const typeDimensionsMap = {
      countries: ',6',
      // TODO: add more
    };

    return typeDimensionsMap[type] || '';
  }

  // Get the available multifilters
  getMultifilters(newDimension: any) {
    const dimensionIDs: Array<number> = _.uniq(this.searchDimensionIDs.concat([parseInt(newDimension.dimension_id)]));
    const params: any = this.setReportParams('multifilters');

    if (
      !_.isEqual(dimensionIDs, this.searchDimensionIDs) &&
      this.availableMultifilters[newDimension.value] === undefined
    ) {
      this.searchDimensionTimeout = setTimeout(() => {
        this.searchDimensionIDs = _.cloneDeep(dimensionIDs);
        if (this.searchDimensionObservable) {
          this.searchDimensionObservable.unsubscribe();
        }
        this.searchDimensionObservable = this.httpService.post(this.endpointURL + '/searchDimension', params).subscribe(
          (response: any) => {
            let availableMultifilters: any;
            if (response.errors === undefined) {
              availableMultifilters = _.cloneDeep(response);
              for (const dimension in availableMultifilters) {
                if (
                  availableMultifilters.hasOwnProperty(dimension) &&
                  Array.isArray(availableMultifilters[dimension])
                ) {
                  if (availableMultifilters[dimension].includes(null)) {
                    availableMultifilters[dimension] = _.without(availableMultifilters[dimension], null);
                    availableMultifilters[dimension].push('');
                  }
                  this.availableMultifilters[dimension] = availableMultifilters[dimension];
                }
              }
              for (const dimension in availableMultifilters) {
                if (_.filter(this.dimensions, { value: dimension })) {
                  this.updateMultifiltersForDimension({ value: dimension });
                }
              }
              for (const dimension in this.multifiltersLoadingState) {
                this.multifiltersLoadingState[dimension] = false;
              }
            }
            this.searchDimensionIDs = [];
            this.focusOnOpenedMultifilter();
          },
          (error: any) => {
            this.sharedService.showErrorFlashMessage();
            this.isLoading = false;
          }
        );
        this.subscriptions.push(this.searchDimensionObservable);
      }, 500);
    }
  }

  // Get a report's total data (for the summary row)
  getReportTotal() {
    const dataTotalRow: any = {};
    const reportParams: any = this.setReportParams('total');
    let currColumn: any;
    // Post the request to get the report-data
    this.subscriptions.push(
      this.httpService.post(this.endpointURL + '/getReportTotal', reportParams).subscribe((response) => {
        // Pass the data to the grid
        for (let i = 0; i < this.columnsSettings.length; i++) {
          currColumn = _.find(this.gridService.reportColumns, { actualKey: this.columnsSettings[i].key });
          if (currColumn !== undefined) {
            if (currColumn.aggregated) {
              dataTotalRow[currColumn.actualKey] = response.data[0][currColumn.reportKey]
                ? parseFloat(response.data[0][currColumn.reportKey])
                : 0;
            } else {
              dataTotalRow[currColumn.actualKey] = '';
            }
          }
        }
        this.dataTotal = dataTotalRow;
        this.sharedService.sendMessage('GRID_DETECT_CHANGES');
        this.isLoading = false;
      })
    );
  }

  // Update the graph's settings
  updateGraphSettings() {
    this.isTotalGraph = this.data.length === this.selectedItems.length && this.reportType !== 'exco-player-release';
    this.isAggregatedGraph =
      this.selectedItems.length > this.reportsService.graphMaxItemsForSingleLines || !this.selectedItems.length;
    this.sharedService.sendMessage('GRID_UPDATE_SELECTED_ITEMS');
  }

  // Parse the report's graph data
  parseGraphData(graphData: Array<any> = []) {
    const data: Array<any> = [];
    let currItem: any = {};
    let columnSettings: any;

    this.gridService.buildColumnsDefaults(this.labsVer);

    for (let i = 0; i < graphData.length; i++) {
      currItem = {};
      for (const key in graphData[i]) {
        columnSettings = this.gridService.getReportColumnSettings(key);
        if (columnSettings) {
          currItem[columnSettings.key] = this.getEntityIDbyName(columnSettings.key, graphData[i][key]);
        }
      }
      data.push(currItem);
    }

    this.graphs.days.data = _.cloneDeep(data);
    this.onResize('updateGraph');
  }

  // Get the sorting cell and direction
  getSorting() {
    const sortCol: string =
      this.reportType === 'content_reports'
        ? 'content_viewed'
        : this.userService.userData.userType === 'cedatopub'
        ? 'cost'
        : 'revenue';
    const sorting: any = { cell: sortCol, dir: 'desc' };
    if (this.sorting) {
      if (!this.sharedService.isEmpty(this.sorting.attrName)) {
        sorting.cell = this.gridService.getReportColumnSettings(this.sorting.attrName).key;
        sorting.dir = this.sorting.sort;
      }
    }
    return sorting;
  }

  // Get the number of days in the current report
  getReportDaysSpan() {
    return moment(this.endDate).diff(this.startDate, 'days') + 1;
  }

  // Determine if the current report is an hourly one
  isHourlyReport() {
    return this.getReportDaysSpan() < 2;
  }

  // Get the number of points-in-time
  getNumOfPointsInTime() {
    const startDate: Date = _.cloneDeep(this.startDate);
    const today: Date = this.reportsService.getCurrentDate(null, null, null, true);
    let isToday: boolean;
    if (this.isHourlyReport()) {
      isToday =
        startDate.getDate() === today.getDate() &&
        startDate.getMonth() === today.getMonth() &&
        startDate.getFullYear() === today.getFullYear();
      return isToday ? parseInt(moment().utc().utcOffset(this.reportsService.getTimezoneOffset()).format('H')) + 1 : 24;
    } else {
      return moment(this.endDate).diff(this.startDate, 'days') + 1;
    }
  }

  // Get graph point-in-time
  getGraphPointInTime(n: number) {
    const currPointInTime: Date = new Date(this.startDate);
    if (this.isHourlyReport()) {
      currPointInTime.setHours(n);
    } else {
      currPointInTime.setDate(currPointInTime.getDate() + n);
      currPointInTime.setHours(0);
    }
    return currPointInTime;
  }

  // On dimension drag start
  onDimensionDragStart($event: any, dimensionIndex: number) {
    this.draggedDimensionIndex = dimensionIndex;
  }

  // On dimension drag end
  onDimensionDragEnd($event: any) {
    this.draggedDimensionIndex = null;
  }

  // On dimension drag over
  onDimensionDragOver($event: any) {
    $event.preventDefault();
  }

  // On dimension drop
  onDimensionDrop($event: any) {
    const orderedDimensions: Array<any> = [];
    const selectedDimensions: HTMLElement = document.getElementById('selectedDimensions');
    const selectedDimensionsItems: NodeListOf<any> = selectedDimensions.getElementsByClassName('selectedDimensionsItem');
    let currDimensionElement: HTMLElement;
    let currDimension: any;
    const dropX: number = $event.clientX - selectedDimensions.getBoundingClientRect().left;
    const deltas: Array<any> = [];
    let newPos: number;
    // Add the delta from the start
    deltas.push(dropX);
    // Calculate the deltas between the drop X and each selceted dimension element
    for (let i = 0; i < selectedDimensionsItems.length; i++) {
      currDimensionElement = selectedDimensionsItems[i];
      deltas.push(Math.abs(dropX - currDimensionElement.offsetLeft));
    }
    // Add the delta from the end
    deltas.push(Math.abs(dropX - selectedDimensions.offsetWidth));
    // The new position is the index of the smallest delta
    newPos = deltas.indexOf(Math.min.apply(null, deltas));
    // Since we pushed the delta from the start, the deltas from each dimension is actually bigger by one than the real value
    if (newPos > 0) {
      newPos--;
    }
    // Since we pushed the delta from the end, the delta from the end will be bigger than the array's length
    if (newPos >= this.selectedDimensions.length) {
      newPos = this.selectedDimensions.length - 1;
    }
    // Reorder the dimensions
    for (let i = 0; i < this.selectedDimensions.length; i++) {
      if (i !== this.draggedDimensionIndex) {
        currDimension = this.selectedDimensions[i];
        orderedDimensions.push(currDimension);
      }
    }
    for (let i: number = this.selectedDimensions.length - 1; i > newPos; i--) {
      orderedDimensions[i] = orderedDimensions[i - 1];
    }
    orderedDimensions[newPos] = this.selectedDimensions[this.draggedDimensionIndex];
    this.selectedDimensions = orderedDimensions;
    // Set the currently dragged dimension to be null
    this.draggedDimensionIndex = null;
    // Update 'Go' button state
    this.updateGoButtonState();
  }

  // Select or unselect a dimension
  toggleSelectDimension(dimension: any, isInit = false) {
    // Reset the multifilters
    this.multifilters[dimension.value] = [];
    this.selectedMultifilters[dimension.value] = [];
    // If the dimension was already selected
    if (this.isDimensionSelected(dimension)) {
      // Delete the available multifilters
      delete this.availableMultifilters[dimension.value];
      // Delete the current multifilters
      delete this.multifilters[dimension.value];
      // If the removed dimension is Supply ID
      if (dimension.value === 'si') {
        // Delete the Supply Name multifilters
        delete this.availableMultifilters.sn;
        delete this.multifilters.sn;
        // If the removed dimension is Demand ID
      } else if (dimension.value === 'di') {
        // Delete the Demand Name multifilters
        delete this.availableMultifilters.dn;
        delete this.multifilters.dn;
        // If the Domain dimension is not selected
        if (!_.map(this.selectedDimensions, 'value').includes('dm')) {
          // Delete the Domain multifilters
          delete this.availableMultifilters.dm;
          delete this.multifilters.dm;
        }
      }
      // Delete the remove dimension
      _.remove(this.selectedDimensions, dimension);
      _.remove(this.selectedDimensionsData, (item: any) => {
        return item.dimension.value === dimension.value;
      });
    } else {
      // Add the toggled dimension
      this.selectedDimensions.push(dimension);
      this.selectedDimensionsData.push({
        dimension: dimension,
        filterMenuToggleStatus: false,
      });
    }

    //is it Demand Report
    this.isDemandReport = this.isItDemandReport();

    // If this is not an injected dimension...
    if (!isInit) {
      //this.userChangedSorting = false;
      this.updateGoButtonState();
    }
    // Fill local multifilters
    this.fillLocalMultifilters();
  }

  // Return if a dimension is selected or not
  isDimensionSelected(dimension: any) {
    return _.find(this.selectedDimensions, dimension) !== undefined;
  }

  // Get a dimension's label
  getDimensionLabel(dimension: any) {
    let label: string = dimension.name;
    const selectedMultifilters: Array<string> = this.multifilters[dimension.value];
    //let entityName: string;
    if (selectedMultifilters !== undefined && !this.multifiltersLoadingState[dimension.value]) {
      if (selectedMultifilters.length > 0) {
        label += ' (' + selectedMultifilters.length + ')';
      }
    }
    return label;
  }

  // Get a dimension's filter toggle-status
  getDimensionFilterToggleStatus(dimension: any) {
    const dimensionData = _.find(this.selectedDimensionsData, { dimension: dimension });
    return dimensionData.filterMenuToggleStatus;
  }

  // Get the multifilters for a dimension
  updateMultifiltersForDimension(dimension: any) {
    let selected: Array<any> = [];
    let notSelected: Array<any> = [];
    let entityKey: any;
    let entityName: string;
    let isSelected: boolean;
    let shouldAdd: boolean;
    let checkBoxLabel: string;
    const notProvidedBySource: string = this.dictionaryService.get('NOT_PROVIDED_BY_SOURCE');
    let notProvidedBySourceItem: any;
    const notDefined: string = this.dictionaryService.get('NOT_DEFINED');
    let notDefinedItem: any;
    let addedItem: any;
    if (this.multifilters[dimension.value] === undefined) {
      this.multifilters[dimension.value] = [];
    }
    if (this.availableMultifilters[dimension.value]) {
      for (let i = 0; i < this.availableMultifilters[dimension.value].length; i++) {
        entityKey = this.availableMultifilters[dimension.value][i];
        entityName = this.getEntityNameById(dimension, entityKey);
        shouldAdd = false;
        switch (dimension.value) {
          // Supply / Demand
          case 'si':
          case 'di':
            isSelected = this.multifilters[dimension.value].includes(entityKey);
            checkBoxLabel = '(' + entityKey + ') ' + entityName;
            break;
          // Environment / Domain / App-Bundle / Sub-ID / Supply Type / Demand Type / Supply Partner / Demand Partner
          case 'en':
          case 'dm':
          case 'ab':
          case 'an':
          case 'sb':
          case 'st':
          case 'sm':
          case 'dt':
          case 'sp':
          case 'dp':
            isSelected =
              this.multifilters[dimension.value].includes(entityName) ||
              this.multifilters[dimension.value].includes(' ' + entityName);
            checkBoxLabel = entityName;
            break;
          // Hour
          case 'hr':
            isSelected = this.multifilters[dimension.value].includes(entityKey);
            checkBoxLabel = this.gridService.parseHour({ value: entityKey });
            break;
          // Everything else
          default:
            isSelected = this.multifilters[dimension.value].includes(entityKey);
            checkBoxLabel = entityKey;
        }
        // Validate that the current multifilters has passed the search criteria
        if (entityKey.toLowerCase().indexOf(this.multifiltersSearch.toLowerCase()) > -1) {
          shouldAdd = true;
        } else if (entityName !== null) {
          if (entityName.toLowerCase().indexOf(this.multifiltersSearch.toLowerCase()) > -1) {
            shouldAdd = true;
          }
        }
        // If we should add the current item (per the search), we'll add it to the relevant array (selected or not-selected)
        if (shouldAdd) {
          addedItem = { label: checkBoxLabel, key: entityKey };
          isSelected ? selected.push(addedItem) : notSelected.push(addedItem);
        }
      }
    }
    // Sorting the items
    if (dimension.value !== 'hr') {
      selected = _.orderBy(selected, 'label', 'asc');
      notSelected = _.orderBy(notSelected, 'label', 'asc');
    } else {
      selected = _.orderBy(
        selected,
        (item: any) => {
          return parseInt(item.key);
        },
        'asc'
      );
      notSelected = _.orderBy(
        notSelected,
        (item: any) => {
          return parseInt(item.key);
        },
        'asc'
      );
    }
    // Shift the "Not provided by source" and "Not defined" items to the top
    if (_.find(selected, { label: notProvidedBySource })) {
      notProvidedBySourceItem = _.remove(selected, { label: notProvidedBySource })[0];
      selected.unshift(notProvidedBySourceItem);
    }
    if (_.find(notSelected, { label: notProvidedBySource })) {
      notProvidedBySourceItem = _.remove(notSelected, { label: notProvidedBySource })[0];
      notSelected.unshift(notProvidedBySourceItem);
    }
    if (_.find(selected, { label: notDefined })) {
      notDefinedItem = _.remove(selected, { label: notDefined })[0];
      selected.unshift(notDefinedItem);
    }
    if (_.find(notSelected, { label: notDefined })) {
      notDefinedItem = _.remove(notSelected, { label: notDefined })[0];
      notSelected.unshift(notDefinedItem);
    }
    // Limit the arrays' lengths
    selected = selected.splice(0, 50);
    notSelected = notSelected.splice(0, 50);
    // Set the multifilters
    this.selectedMultifilters[dimension.value] = { selected: selected, notSelected: notSelected };
  }

  // Focus on the opened multifilter's input box
  focusOnOpenedMultifilter() {
    let multifilterList: Array<Element>;
    let inputs: Array<HTMLInputElement>;
    setTimeout(() => {
      multifilterList = Array.from(document.getElementsByClassName('multifilterList'));
      if (multifilterList.length > 0) {
        inputs = Array.from(multifilterList[0].getElementsByTagName('input'));
        if (inputs.length > 0) {
          inputs[0].focus();
        }
      }
    }, 400);
  }

  getEntityNameById(dimension: any, id: any) {
    let name: string = id;
    let index: number;
    switch (dimension.value) {
      // Supply
      case 'si':
      case 'supply_id':
        index = _.findIndex(this.availableMultifilters['si'], (item: string) => item === id.toString());
        if (index > -1) {
          name = this.availableMultifilters['sn'][index];
        }
        break;
      // Demand
      case 'di':
      case 'demand_id':
        index = _.findIndex(this.availableMultifilters['di'], (item: string) => item === id.toString());
        if (index > -1) {
          name = this.availableMultifilters['dn'][index];
        }
        break;
      // Environment
      case 'en':
      case 'environment':
        name = this.gridService.parseEnvironmentTooltip({ value: id });
        break;
      // Supply Type
      case 'st':
      case 'supply_type':
        name = this.gridService.parseSupplyType({ value: id }, false);
        break;
      // Supply Method
      case 'sm':
      case 'supply_method':
        name = this.gridService.parseSupplyMethod({ value: id }, false);
        break;
      // Demand Type
      case 'dt':
      case 'demand_type':
        name = this.gridService.parseDemandType({ value: id }, false);
        break;
      default:
        name = id;
    }
    return name;
  }

  getEntityIDbyName(dimension: any, name: any) {
    let res: string;
    switch (dimension) {
      // Environment
      case 'en':
      case 'environment':
        res = _.find(this.sharedService.envTypes, { view: name })
          ? _.find(this.sharedService.envTypes, { view: name })['id'].toString()
          : name;
        break;
      // Supply Type
      case 'st':
      case 'supply_type':
        res = _.find(this.supplyService.supplyTypes, { view: name })
          ? _.find(this.supplyService.supplyTypes, { view: name })['id'].toString()
          : name;
        break;
      // Supply Method
      case 'sm':
      case 'supply_method':
        res = _.find(this.supplyService.supplyMethods, { view: name })
          ? _.find(this.supplyService.supplyMethods, { view: name })['id'].toString()
          : name;
        break;
      // Demand Type
      case 'dt':
      case 'demand_type':
        res = _.find(this.demandService.demandTypes, { view: name })
          ? _.find(this.demandService.demandTypes, { view: name })['id'].toString()
          : name;
        break;
      default:
        res = name;
    }
    return res;
  }

  // Toggle a multifilter
  toggleMultifilter(dimension: any, entityKey: string) {
    let index: number;
    const entityName: string =
      dimension.value === 'si' || dimension.value === 'di' ? entityKey : this.getEntityNameById(dimension, entityKey);
    if (this.multifilters[dimension.value] === undefined) {
      this.multifilters[dimension.value] = [];
    }
    index = this.multifilters[dimension.value].indexOf(entityName);
    index > -1
      ? this.multifilters[dimension.value].splice(index, 1)
      : this.multifilters[dimension.value].push(entityName);
    this.updateGoButtonState();
  }

  // Update 'Go' button state
  updateGoButtonState(fromCancelButon: boolean = false) {
    const newReportDimensions: string = _.map(this.selectedDimensions, 'dimension_id').join(',');
    const newReportMultifilters: any = _.cloneDeep(this.multifilters);
    delete newReportMultifilters.sn;
    delete newReportMultifilters.dn;
    delete newReportMultifilters.sql;
    if (!fromCancelButon) {
      this.goButtonState =
        !_.isEqual(newReportDimensions, this.lastReportDimensions) ||
        !_.isEqual(newReportMultifilters, this.lastReportMultifilters);
    } else {
      this.goButtonState =
        !_.isEqual(this.lastReportDimensions, this.fetchedReportDimensions) ||
        !_.isEqual(this.lastReportMultifilters, this.fetchedReportMultifilters);
    }
  }

  // Show the graph in full-screen (for smaller displays)
  showGraphFullScreen() {
    const graphWrapper = document.getElementById('graphWrapper');
    if (!this.graphToggleStatus) {
      this.toggleGraph();
    }
    if (document.fullscreenEnabled) {
      graphWrapper.requestFullscreen();
    } else if (document.webkitFullscreenEnabled) {
      graphWrapper.webkitRequestFullScreen();
    }
  }

  setGraphKey(key: any) {
    this.graphCurrKey = key;
    this.graphDimension = this.gridService.getReportKeyByActualKey(key);
  }

  // Change the graph's key
  changeGraphKey(key: any) {
    this.setGraphKey(key);
    if (document.getElementById('graph')) {
      this.updateGraphPoints();
      if (!this.graphToggleStatus) {
        this.toggleGraph();
      }
    }
  }

  changeSelectedCountry(newVal: string) {
    this.selectedCountry = newVal;
  }

  // Expand or collapse the graph
  toggleGraph() {
    this.graphToggleStatus = !this.graphToggleStatus;
    localStorage.setItem('graphToggleStatus', this.graphToggleStatus.toString());
      if (this.graphToggleStatus) {
        this.updateGraphTransform();
      }
  }

  // Handle a 'start-date-changed' event from the datepicker component
  startDateChanged($event: any) {
    this.startDate = $event;
  }

  // Handle an 'end-date-changed' event from the datepicker component
  endDateChanged($event: any) {
    this.endDate = $event;
    if ($event) {
      this.resetReportSettings(false);
      this.onGoButtonClick();
    }
  }

  // Update the dates range (an object for the grid's 'Day' filter)
  updateDatesRange() {
    this.datesRange = {
      startDate: this.startDate,
      endDate: this.endDate,
    };
  }

  // Select/Unselect one item
  onItemSelectChange($event: any) {
    const item: any = _.cloneDeep($event.dataItem);
    if (item.$$selected) {
      this.selectedItems.push(item);
    } else {
      _.remove(this.selectedItems, (selectedItem: any) => {
        return selectedItem.$$uuid === item.$$uuid;
      });
    }
    this.data = _.cloneDeep(this.data);
    this.selectedItems = _.filter(this.data, '$$selected');
    this.updateGraphSettings();

    if (this.graphs.days.isLoading) {
      if (this.graphs.days.getGraphSubscription) {
        this.graphs.days.getGraphSubscription.unsubscribe();
      }
      this.graphs.days.isLoading = false;
    }
    this.buildGraphs();
    if (!this.graphToggleStatus) {
      this.toggleGraph();
    }
  }

  // Select all/none
  onSelectAllChange($event: any) {
    let reportParams: any;
    let storedGraphData: any;
    const allSelectedCount: number = _.filter($event, { $$selected: true }).length;
    const allSelectedState: boolean = _.filter($event, { $$selected: false }).length === 0;
    this.selectedItems = allSelectedState && this.data.length !== allSelectedCount ? _.cloneDeep(this.data) : [];
    reportParams = this.setReportParams('graph');
    if (!this.sharedService.isEmpty(localStorage.getItem('currentGraphData'))) {
      storedGraphData = JSON.parse(localStorage.getItem('currentGraphData'));
    }
    if (
      storedGraphData.networkId &&
      storedGraphData.networkId === this.userService.networkData.networkId &&
      storedGraphData.title &&
      storedGraphData.title === this.title &&
      storedGraphData.params &&
      _.isEqual(storedGraphData.params, reportParams) &&
      storedGraphData.data
    ) {
      if (!this.isTotalGraph) {
        this.updateGraphSettings();
        this.parseGraphData(storedGraphData.data);
      }
    } else {
      this.updateGraphSettings();
      this.buildGraph();
      if (!this.graphToggleStatus) {
        this.toggleGraph();
      }
    }
  }

  // Abort Report query, set default timeout values
  onReportShouldGoByEmail(isReportTimeout: boolean) {
    this.isLoading = false;
    this.isReportTimeout = false;
    this.getReportObservable.unsubscribe();
    if (isReportTimeout) {
      this.data = [];
    }
  }

  // Update the graph's transform (on resize or side-menu-toggle-change)
  updateGraphTransform() {
    const graphWrapper: HTMLElement = document.getElementById('graphWrapper');
    if (graphWrapper) {
      this.graphWidth = graphWrapper.clientWidth;
    }

    this.updateGraphData();
  }

  // Update the graph's data
  updateGraphData() {
    const numOfPointsInTime: number = this.getNumOfPointsInTime();
    const isHourlyReport: boolean = this.isHourlyReport();
    let primaryKeys: Array<string>;
    let currGraphItem: any;
    let currPointInTime: Date;
    let currItemInCurrTime: any;
    let allItemsInCurrTime: Array<any>;
    let currItemData: any;
    let isFirst = true;

    // Reset the graph items data
    this.graphItemsData = [];
    // If there's only one item, and all of its values equal null, we'll reset the graph's data
    if (this.graphs.days.data.length === 1) {
      Object.keys(this.graphs.days.data[0]).forEach(
        (key: any) => this.graphs.days.data[0][key] === null && delete this.graphs.days.data[0][key]
      );
      if (this.sharedService.getNumOfKeys(this.graphs.days.data[0]) === 0) {
        this.graphs.days.data = [];
      }
    }

    // If there's any data...
    if (this.graphs.days.data.length > 0) {
      // Get the graph properties
      this.reportsService.buildGraphDefaults(this.labsVer);
      _.forEach(this.graphs.days.data[0], (v: any, k: string) => {
        const find: any = _.find(this.gridService.reportColumns, { actualKey: k });
        if (
          (this.labsVer === 1 || this.measuresArr.includes(find.reportKey)) &&
          _.find(this.reportsService.graphDefaults, { key: k })
        ) {
          if (isFirst) {
            this.graphProperties = [_.find(this.reportsService.graphDefaults, { key: k })];
            isFirst = false;
          } else {
            this.graphProperties.push(_.find(this.reportsService.graphDefaults, { key: k }));
          }
        }
      });

      // If the current graph key isn't set, set it to be the first option
      if (this.sharedService.isEmpty(this.graphCurrKey) && this.graphProperties[0]) {
        this.setGraphKey(this.graphProperties[0].key);
      }
      // If this is an aggregated graph...
      if (this.isAggregatedGraph) {
        // Create the aggregated item
        currGraphItem = { data: [] };
        // For all of the points in time...
        for (let i = 0; i < numOfPointsInTime; i++) {
          // Create an empty object
          currItemInCurrTime = {};
          // Reset the items in the current point in time
          allItemsInCurrTime = this.getGraphPoint(this.graphs.days.data, isHourlyReport, i);

          // For all of the graph properties...
          this.graphProperties.forEach((property: any) => {
            currItemInCurrTime[property.key] = this.gridService.aggregate(
              allItemsInCurrTime,
              this.columnsSettings,
              property.key
            );
          });
          // Add the current item's data in the current point-in-time to the item's data array
          currGraphItem.data.push(currItemInCurrTime);
        }

        // Set the graph items to the aggregated item
        this.graphItemsData = [currGraphItem];
      } else if (this.isTotalGraph) {
        // Create the aggregated item
        currGraphItem = { data: [] };
        for (let i = 0; i < numOfPointsInTime; i++) {
          // Create an empty object
          currItemInCurrTime = {};
          // Reset the items in the current point in time
          allItemsInCurrTime = this.getGraphPoint(this.graphs.days.data, isHourlyReport, i);
          // For all of the graph properties...
          this.graphProperties.forEach((property: any) => {
            currItemInCurrTime[property.key] = this.gridService.aggregate(
              allItemsInCurrTime,
              this.columnsSettings,
              property.key
            );
          });
          // Add the current item's data in the current point-in-time to the item's data array
          currGraphItem.data.push(currItemInCurrTime);
        }

        // Set the graph items to the aggregated item
        this.graphItemsData = [currGraphItem];
      } else {
        // If there are any selected items
        if (this.selectedItems.length > 0) {
          // Get the primary keys
          this.primaryKeys = this.getPrimaryKeys();
          // Save the primary key locally
          primaryKeys = this.primaryKeys;

          // For all of the items in the graph...
          this.selectedItems.forEach((itemId: any, index: number) => {
            // Create a new object, for the current item's points
            currGraphItem = { data: [] };
            // Filter the current item's data
            currItemData = _.cloneDeep(
              _.filter(this.graphs.days.data, (item: any) => {
                let shouldReturn = true;
                primaryKeys.forEach((key: string) => {
                  if (item[key] !== this.selectedItems[index][key]) {
                    shouldReturn = false;
                  }
                });

                return shouldReturn ? item : false;
              })
            );

            // For all of the points in time...
            for (let i = 0; i < numOfPointsInTime; i++) {
              // Set the current point-in-time
              currPointInTime = this.getGraphPointInTime(i);
              // Find the current item's data in the current point-in-time
              currItemInCurrTime = _.find(currItemData, (item: any) => {
                let day: Date;
                if (isHourlyReport) {
                  return parseInt(item.hour) === currPointInTime.getHours();
                } else {
                  day = new Date(item.day);
                  day.setHours(0);
                  return day.getTime() === currPointInTime.getTime();
                }
              });
              // If there's no data for this item in this point-in-time...
              if (currItemInCurrTime === undefined) {
                // ...we'll set everything to zero
                currItemInCurrTime = {};
                // For all of the graph properties...
                this.graphProperties.forEach((property: any) => {
                  currItemInCurrTime[property.key] = 0;
                });
              } else {
                // Else, parse relevant properties as floats and delete the redundant ones
                for (const property in currItemInCurrTime) {
                  if (_.find(this.graphProperties, { key: property })) {
                    currItemInCurrTime[property] = parseFloat(currItemInCurrTime[property]);
                  } else {
                    delete currItemInCurrTime[property];
                  }
                }
              }

              // Add the current item's data in the current point-in-time to the item's data array
              currGraphItem.data.push(currItemInCurrTime);
            }

            // Add the current item's data to the graph items data
            this.graphItemsData.push(currGraphItem);
          });
        }
      }
    }

    // Update the graph
    _.find(this.graphProperties, { key: this.graphCurrKey }) || this.graphProperties.length === 0
      ? this.updateGraphPoints()
      : this.changeGraphKey(this.graphProperties[0].key);

    setTimeout(() => {
      this.displayGraphControls();
    });
  }

  getGraphKeyLabel(key: string) {
    const prop = _.find(this.graphProperties, { key });
    return prop ? prop.label : '';
  }

  // Clear the graph
  clearGraph() {
    const graph: HTMLElement = document.getElementById('graph');
    if (graph) {
      while (graph.firstChild) {
        graph.removeChild(graph.firstChild);
      }
    }
  }

  displayGraphControls() {
    const graphMeasuresButtons: HTMLElement = document.getElementById('graphKeysButtons');
    if (graphMeasuresButtons) {
      graphMeasuresButtons.classList.add('calculate');
      this.showGraphButtons = !(graphMeasuresButtons.clientWidth + 100 > this.graphWidth);
      graphMeasuresButtons.classList.remove('calculate');
    }
  }

  getGraphPoint(graphData: Array<any> = [], isHourlyReport: boolean = false, i: number = 0) {
    const currPointInTime: Date = this.getGraphPointInTime(i);
    // Find the current item's data in the current point-in-time
    return _.filter(graphData, (item: any) => {
      let day: Date;
      if (isHourlyReport) {
        return parseInt(item.hour) === currPointInTime.getHours();
      } else {
        day = new Date(item.day);
        day.setHours(0);
        return day.getTime() === currPointInTime.getTime();
      }
    });
  }

  // Update the graph's points-data
  updateGraphPoints() {
    const graphKeySettings: any = _.find(this.reportsService.graphProperties, { key: this.graphCurrKey });
    const allowDecimal: boolean = graphKeySettings ? graphKeySettings.decimal : false;
    const numOfPointsInTime: number = this.getNumOfPointsInTime();
    const graphRightPadding = 96;
    const graphPointOffset = 8;
    let x = 0;
    let y = 0;
    let currTooltip: number;
    let currTooltipStr: string;
    let currDate: any;
    let defaultSettings: any;
    // Reset the values
    this.graphXPoints = [];
    this.graphYPoints = [];
    this.graphMaxPoint = 0;
    // Calculate the x values of the graph-points
    for (let i = 0; i < numOfPointsInTime; i++) {
      x =
        numOfPointsInTime === 0
          ? 0
          : Math.round((i / (numOfPointsInTime - 1)) * (this.graphWidth - graphRightPadding)) + this.graphXOffset;
      if (isNaN(x)) {
        x = 0;
      }
      this.graphXPoints.push(x);
    }
    // Calculate the highest y point
    for (let i = 0; i < this.graphItemsData.length; i++) {
      for (let j = 0; j < this.graphItemsData[i].data.length; j++) {
        if (this.graphItemsData[i].data[j][this.graphCurrKey] !== undefined) {
          this.graphMaxPoint = Math.max(
            this.graphMaxPoint,
            parseFloat(this.graphItemsData[i].data[j][this.graphCurrKey])
          );
        }
      }
    }
    this.graphMaxPoint = this.sharedService.roundUp(this.graphMaxPoint, allowDecimal);
    // Calculate y values of the graph-points
    this.graphPoints = [];
    for (let i = 0; i < this.graphItemsData.length; i++) {
      this.graphYPoints[i] = [];
      this.graphPoints[i] = [];
      for (let j = 0; j < this.graphItemsData[i].data.length; j++) {
        y =
          this.graphMaxPoint === 0 || this.graphItemsData[i].data[j][this.graphCurrKey] === undefined
            ? this.graphFloorY
            : Math.round(
                this.graphFloorY -
                  (parseFloat(this.graphItemsData[i].data[j][this.graphCurrKey]) / this.graphMaxPoint) *
                    (this.graphFloorY - this.graphYOffset)
              );
        if (isNaN(y)) {
          y = 0;
        }
        this.graphYPoints[i][j] = y;
        // Tooltip
        defaultSettings = _.find(this.gridService.columnsDefaults, { key: this.graphCurrKey });
        currTooltip = this.graphItemsData[i].data[j][this.graphCurrKey];
        if (this.sharedService.isEmpty(currTooltip)) {
          currTooltip = 0;
        }
        currTooltipStr = currTooltip.toLocaleString(undefined, { maximumFractionDigits: 2 });
        if (defaultSettings) {
          if (defaultSettings.measurement) {
            if (defaultSettings.measurement.align === 'right') {
              currTooltipStr += defaultSettings.measurement.char;
            } else {
              currTooltipStr = defaultSettings.measurement.char + currTooltipStr;
            }
          }
        }
        currTooltipStr += '<br/>';
        if (this.isHourlyReport()) {
          currTooltipStr += this.gridService.parseHour({ value: j });
        } else {
          currDate = new Date(this.startDate.getTime());
          currDate.setHours(0);
          currDate.setDate(currDate.getDate() + j);
          currTooltipStr += moment(currDate).format('MMM D');
        }
        // Current point object
        this.graphPoints[i][j] = {
          x: this.graphXPoints[j] + this.graphXOffset - graphPointOffset,
          y: y - graphPointOffset,
          value: currTooltipStr,
        };
      }
    }
    // Clear the
    this.clearGraph();
    // Update the graph's
    this.drawGraph();
    // Show the graph and hide the spinner
    this.graphs.days.isLoading = false;
    // Force changes detection
    this.sharedService.sendMessage('GRID_DETECT_CHANGES');
  }

  // Draw the graph
  drawGraph() {
    const svgURL = 'http://www.w3.org/2000/svg';
    const graph: HTMLElement = document.getElementById('graph');
    const numOfPointsInTime: number = this.getNumOfPointsInTime();
    const pointsInterval: number = Math.floor(this.isHourlyReport() ? numOfPointsInTime / 3 : numOfPointsInTime / 5);
    let displayPointInTime: boolean;
    let currElement: any;
    let currInnerElement: any;
    let currValue: string;
    let currPointTime: Date;
    let lastPoint = false;
    let x1: number;
    let y1: number;
    let x2: number;
    let y2: number;
    // If the graph element exists...
    if (graph) {
      // Draw the floor
      currElement = document.createElementNS(svgURL, 'line');
      currElement.setAttribute('x1', '0');
      currElement.setAttribute('y1', this.graphFloorY);
      currElement.setAttribute('x2', this.graphWidth);
      currElement.setAttribute('y2', this.graphFloorY);
      currElement.setAttribute('style', 'stroke: black; stroke-width: 1');
      graph.appendChild(currElement);
      // Draw the dates/hours
      currElement = document.createElementNS(svgURL, 'svg');
      for (let i = 0; i < numOfPointsInTime; i++) {
        displayPointInTime = i === 0 || i === numOfPointsInTime - 1;
        lastPoint = i === numOfPointsInTime - 1;
        if (this.sharedService.layout !== 'small') {
          displayPointInTime = displayPointInTime || numOfPointsInTime < 10 || i % pointsInterval === 0;
        }
        if (displayPointInTime) {
          if (this.isHourlyReport()) {
            currValue = this.gridService.parseHour({ value: i });
          } else {
            currPointTime = new Date(this.startDate.getTime());
            currPointTime.setDate(currPointTime.getDate() + i);
            currValue = moment(currPointTime).format('MMM D').toUpperCase();
          }
          if (numOfPointsInTime - i > pointsInterval / 2 || lastPoint) {
            currInnerElement = document.createElementNS(svgURL, 'text');
            currInnerElement.setAttribute('x', this.graphXPoints[i]);
            currInnerElement.setAttribute('y', this.graphFloorY + 20);
            currInnerElement.setAttribute('font-family', 'Rubik');
            currInnerElement.setAttribute('font-size', '14');
            currInnerElement.setAttribute('style', 'color: black; font-weight: bold');
            currInnerElement.textContent = currValue;
            currElement.appendChild(currInnerElement);
          }
        }
      }
      graph.appendChild(currElement);
      // Draw the scales
      currElement = document.createElementNS(svgURL, 'svg');
      for (let i = 0; i < this.graphScalesNum; i++) {
        // Scale y value
        y1 = this.graphFloorY - ((i + 1) / this.graphScalesNum) * (this.graphFloorY - this.graphYOffset);
        // Scale textual value
        if (this.graphMaxPoint > 0) {
          currValue = (((i + 1) / this.graphScalesNum) * this.graphMaxPoint).toString();
          currValue = parseFloat(currValue).toString();
          currValue = this.gridService.abbreviateNumber(parseFloat(currValue.replace(',', '')), this.graphCurrKey);
        } else {
          currValue = '';
        }
        // Scale line
        currInnerElement = document.createElementNS(svgURL, 'line');
        currInnerElement.setAttribute('x1', 0);
        currInnerElement.setAttribute('y1', y1);
        currInnerElement.setAttribute('x2', this.graphWidth);
        currInnerElement.setAttribute('y2', y1);
        currInnerElement.setAttribute('style', 'stroke: #E6E6E6; stroke-width: 1');
        currElement.appendChild(currInnerElement);
        // Scale text
        currInnerElement = document.createElementNS(svgURL, 'text');
        currInnerElement.setAttribute('x', 0);
        currInnerElement.setAttribute('y', y1 + 16);
        currInnerElement.setAttribute('font-family', 'Rubik');
        currInnerElement.setAttribute('font-size', '14');
        currInnerElement.setAttribute('style', 'color: black');
        currInnerElement.textContent = currValue;
        currElement.appendChild(currInnerElement);
      }
      graph.appendChild(currElement);
      // Draw the lines and fills
      for (let i = 0; i < this.graphItemsData.length; i++) {
        currElement = document.createElementNS(svgURL, 'svg');
        for (let j = 0; j < this.graphItemsData[i].data.length - 1; j++) {
          // Coordinates
          x1 = this.graphXPoints[j] + this.graphXOffset;
          y1 = this.graphYPoints[i][j];
          x2 = this.graphXPoints[j + 1] + this.graphXOffset;
          y2 = this.graphYPoints[i][j + 1];
          // Fills
          if (this.isAggregatedGraph || this.isTotalGraph) {
            currInnerElement = document.createElementNS(svgURL, 'path');
            currValue = '';
            currValue += 'M' + x1 + ' ' + y1 + ' ';
            currValue += 'L' + x2 + ' ' + y2 + ' ';
            currValue += 'L' + x2 + ' ' + this.graphFloorY + ' ';
            currValue += 'L' + x1 + ' ' + this.graphFloorY + ' ';
            currValue += 'Z';
            currInnerElement.setAttribute('d', currValue);
            currInnerElement.setAttribute('fill', 'rgba(63, 169, 245, 0.15)');
            currElement.appendChild(currInnerElement);
          }
          // Lines
          currInnerElement = document.createElementNS(svgURL, 'line');
          currInnerElement.setAttribute('x1', x1);
          currInnerElement.setAttribute('y1', y1);
          currInnerElement.setAttribute('x2', x2);
          currInnerElement.setAttribute('y2', y2);
          currInnerElement.setAttribute(
            'style',
            'stroke: ' +
              (this.reportsService.graphColors[i] ? this.reportsService.graphColors[i].hex : '#44ABF3') +
              '; stroke-width:4'
          );
          currElement.appendChild(currInnerElement);
        }
        graph.appendChild(currElement);
      }
    }
  }

  // Get graph point color
  getGraphPointColor(i: number) {
    let className = 'graphPoint';
    if (this.selectedItems.length > 0 && this.selectedItems.length <= this.reportsService.graphMaxItemsForSingleLines) {
      className += ' graphPoint' + i.toString();
    }
    return className;
  }

  // Get graph point label
  getGraphPointLabel(item: any) {
    let label = '';
    this.primaryKeys.forEach((key: string, index: number) => {
      if (index !== 0) {
        label += ' ' + this.dictionaryService.get('BY').toLowerCase() + ' ';
      }
      switch (key) {
        case 'supply_id':
        case 'demand_id':
          label += item[key];
          break;
        case 'hour':
          label += this.gridService.parseHour({ value: item[key] });
          break;
        default:
          label += this.getEntityNameById({ value: key }, item[key]);
          break;
      }
    });
    return label;
  }

  // Update the totals row
  updateTotalsRow() {
    const dataTotal: any = {};
    const columnsSettings: Array<any> = [];
    let defaultSettings: any;
    let isAggregated: boolean;
    // Create a shortened version of the columns settings (only the keys, nothing else is relevant)
    if (this.data.length > 0) {
      for (const key in this.data[0]) {
        columnsSettings.push({ key: key });
      }
    }
    // Reset all columns to zero
    columnsSettings.forEach((column: any) => {
      isAggregated = false;
      defaultSettings = _.find(this.gridService.reportColumns, { actualKey: column.key });
      if (defaultSettings) {
        if (defaultSettings.aggregated) {
          isAggregated = true;
        }
      }
      if (isAggregated) {
        dataTotal[column.key] = 0;
      }
    });
    // If there's any data at all..
    if (this.data.length > 0) {
      // For all of the columns...
      for (const key in this.data[0]) {
        // If this is an aggregated columns...
        if (dataTotal[key] !== undefined) {
          // Aggregate the data
          dataTotal[key] = this.gridService.aggregate(this.data, columnsSettings, key);
        }
      }
    }
    // Pass the data to the grid
    this.dataTotal = dataTotal;
  }

  // On 'Save report' button-click
  onSaveReportButtonClick() {
    setTimeout(() => {
      this.modalsService.showModal({
        component: 'report-actions',
        title: this.dictionaryService.get('SAVE_REPORT'),
        data: { dialogue: 'SAVE', reportData: this.queryParams },
      });
    }, 600);
  }

  // On 'Copy report' button-click
  onCopyReportButtonClick() {
    this.modalsService.showModal({
      component: 'report-actions',
      title: this.dictionaryService.get('COPY_REPORT'),
      data: { dialogue: 'COPY', reportData: this.queryParams },
    });
  }

  // On 'Delete report' button-click
  onDeleteReportButtonClick() {
    this.modalsService.showModal({
      component: 'report-actions',
      title: this.dictionaryService.get('DELETE_REPORT'),
      data: { dialogue: 'DELETE', reportData: this.queryParams },
    });
  }

  // Send Report by Email
  // also on report timeout (DAS-3730)
  onReportReportByEmail(reportParams: any) {
    this.modalsService.showModal({
      component: 'report-actions',
      title: this.dictionaryService.get('EMAIL_REPORT'),
      data: { dialogue: 'EMAIL', reportData: reportParams },
    });
  }

  // On a sort change event, emitted by the grid
  onSortChange($event: any) {
    const sortCell = _.find(this.gridService.reportColumns, { actualKey: $event.sortCell });
    if (sortCell) {
      this.userChangedSorting = true;
      this.sorting = {
        attrName: sortCell.reportKey,
        sort: $event.sortDir,
      };
      if (this.isBigReport) {
        this.onGoButtonClick(false, false, true);
      } else {
        this.onGoButtonClick(false, true);
      }
    }
  }

  // On a filter change event, emitted by the grid
  onFilterChange($event: any) {
    this.filters = this.parseFiltersForReport($event);
    this.filtersForGrid = _.cloneDeep($event);
    this.onGoButtonClick();
  }

  // Parse filters for report (from actual names to report names)
  parseFiltersForReport($event: any) {
    const newFilters: any = {};
    let currCell: any;
    let currValue: any;
    for (const property in $event) {
      currValue = $event[property];
      currCell = _.find(this.gridService.reportColumns, { actualKey: property });
      if (currCell) {
        if (['en', 'st', 'sm', 'dt', 'sp', 'dp'].includes(currCell.reportKey)) {
          currValue = this.getEntityNameById({ value: currCell.reportKey }, currValue);
        }
        if (currCell && !this.sharedService.isEmpty(currValue)) {
          newFilters[currCell.reportKey] = currValue;
        }
        if (currCell && _.isPlainObject(currValue) && !this.sharedService.isEmptyObj(currValue)) {
          let stringValue = '';
          _.forEach(currValue, (v, k) => {
            if (v && !_.isNaN(parseFloat(v.toString().replace(/[^0-9.]/g, '')))) {
              stringValue += stringValue === '' ? '' : '-';
              stringValue += k + '_' + parseFloat(v.toString().replace(/[^0-9.]/g, ''));
            }
          });
          newFilters[currCell.reportKey] = stringValue;
        }
      }
    }
    return newFilters;
  }

  // Parse filters for grid (from report names to actual names)
  parseFiltersForGrid() {
    const filters: any = {};
    let columnSettings: any;
    for (const property in this.filters) {
      columnSettings = this.gridService.getReportColumnSettings(property);
      if (columnSettings) {
        filters[columnSettings.key] = this.filters[property];
        if (this.sharedService.isNumeric(filters[columnSettings.key])) {
          filters[columnSettings.key] = Number(filters[columnSettings.key]);
        }
      }
    }
    return filters;
  }

  // Get the date in the report format
  getDateInReportFormat(date: Date, startOrEnd: string) {
    let reportDate: Date = new Date(date);
    if (startOrEnd === 'start') {
      reportDate = new Date(reportDate.setHours(0, 0, 0, 0));
    } else if (startOrEnd === 'end') {
      reportDate = new Date(reportDate.setHours(23, 59, 59, 0));
    }
    return moment(reportDate).format('ddd MMM DD YYYY HH:mm:ss').toString();
  }

  getPrimaryKeys() {
    const primaryKeys: Array<string> = [];
    let dimensions: Array<string> = _.map(this.dimensions, (dimension: any) => {
      const column: any = _.find(this.gridService.reportColumns, { reportKey: dimension.value });
      return column ? column.actualKey : false;
    });
    if (!this.selectedItems[0]) {
      return primaryKeys;
    }
    // Filter the relevant dimensions
    dimensions.forEach((dimension: string) => {
      if (this.sharedService.isEmpty(this.selectedItems[0][dimension])) {
        dimensions = _.without(dimensions, dimension);
      }
    });
    // For all of the columns...
    this.columnsSettings.forEach((column: any) => {
      // If the first item has a property with this column's key, and this column was left in the filtering process...
      if (dimensions.includes(column.key) && !this.sharedService.isEmpty(this.selectedItems[0][column.key])) {
        // Then this is a primary key
        primaryKeys.push(column.key);
      }
    });
    return primaryKeys;
  }

  setReportParams(type: string = '') {
    let queryParams: any;
    let primaryKeys: any = [];
    const reportParams: any = {
      dimensions: _.map(this.selectedDimensions, 'dimension_id').join(','),
      startDate: this.getDateInReportFormat(this.startDate, 'start'),
      endDate: this.getDateInReportFormat(this.endDate, 'end'),
    };
    // Labs version
    if (this.labsVer) {
      reportParams.labs_ver = this.labsVer;
    }
    // Report Type
    if (this.reportType) {
      reportParams.report_type = this.reportType;
    }
    // Limit
    if (this.reportType === 'exco-player-release') {
      reportParams.limit = 5;
    } else if (!['csv', 'multifilters'].includes(type)) {
      reportParams.limit = this.reportsService.queriesLimit;
    }
    // Show Demand Status
    if (type === 'csv' && this.showDemandStatus) {
      reportParams.showDemandStatus = this.showDemandStatus ? '1' : '0';
    }
    // Timezone
    if (!this.sharedService.isEmpty(localStorage.getItem('selectedTimezone'))) {
      reportParams.offset = this.reportsService.getTimezoneOffset();
    }
    // Multifilters
    if (type !== 'multifilters') {
      // Filters & Multifilters
      reportParams.multifilters = _.cloneDeep(this.multifilters);
      reportParams.filters = _.cloneDeep(this.filters);
      for (const property in reportParams.filters) {
        if (reportParams.filters.hasOwnProperty(property)) {
          reportParams.filters[property] =
            typeof reportParams.filters[property] === 'string'
              ? reportParams.filters[property].replace(`'`, `\\'`)
              : reportParams.filters[property];
        }
      }
    }
    // Graph
    if (type === 'graph') {
      if (this.selectedItems.length && this.data.length
        && (this.reportType === 'exco-player-release' || this.selectedItems.length !== this.data.length)) {
        primaryKeys = this.getPrimaryKeys();
        let i = 0;
        reportParams.aggregated = !(
          this.selectedItems.length <= this.reportsService.graphMaxItemsForSingleLines ||
          this.selectedItems.length === this.data.length
        );
        reportParams.selected = [];
        this.selectedItems.forEach((item: any) => {
          reportParams.selected[i] = {};
          primaryKeys.forEach((one: any) => {
            if (_.find(this.gridService.reportColumns, { actualKey: one })) {
              const thisRow = _.find(this.gridService.reportColumns, { actualKey: one });
              reportParams.selected[i][thisRow.reportKey] = this.getEntityNameById({ value: one }, item[one]);
            }
          });

          i++;
        });
      }
      if (this.reportType === 'exco-player-release') {
        reportParams.s = 'sop,desc';
      }
    }

    //Measures Array
    if (this.measuresArr.length && +this.labsVer === 2) {
      reportParams.measures = this.measuresArr;
    }

    //Selected Tab
    //Currently applied only to custom Publishers reports
    if (this.tabsData.length) {
      reportParams.tab =
        this.tabsData[this.tabIndexSelected] && this.tabsData[this.tabIndexSelected]['key']
          ? this.tabsData[this.tabIndexSelected]['key']
          : null;
    }

    // Sorting: not for total query
    if (!['total', 'multifilters'].includes(type)) {
      if (this.sharedService.getNumOfKeys(this.sorting) > 0) {
        reportParams.sorting = {};
        for (const key in this.sorting) {
          if (this.sorting.hasOwnProperty(key)) {
            reportParams.sorting[key] = this.sorting[key];
          }
        }
        if (!_.find(this.gridService.reportColumns, { reportKey: this.sorting.attrName })) {
          queryParams = this.generateQueryParams();
          this.router.navigate([], { queryParams: queryParams }).then(() => {
            return;
          });
        }
      }
      if (reportParams.sorting === undefined || reportParams.sorting.attrName === undefined) {
        reportParams.sorting = this.setDefaultSorting();
      }

      this.sorting = reportParams.sorting;
    }
    return reportParams;
  }

  generateQueryParams() {
    const dayDimensionIndex: number = _.findIndex(this.selectedDimensions, { value: 'dy' });
    const hourDimensionIndex: number = _.findIndex(this.selectedDimensions, { value: 'hr' });
    const queryParams = _.cloneDeep(this.queryParams);

    if (hourDimensionIndex !== -1 && dayDimensionIndex !== -1) {
      queryParams.s = hourDimensionIndex > dayDimensionIndex ? 'dy,desc' : 'hr,desc';
    } else if (hourDimensionIndex !== -1) {
      queryParams.s = 'hr,desc';
    } else if (dayDimensionIndex !== -1) {
      queryParams.s = 'dy,desc';
    } else {
      if (+this.labsVer === 1) {
        if (this.measuresArr.length) {
          queryParams.s = this.measuresArr.includes('r') ? 'r,desc' : `${this.measuresArr[0]},desc`;
        } else {
          queryParams.s = 'r,desc';
        }
      } else if (this.reportType === 'content_reports') {
        if (this.measuresArr.length) {
          queryParams.s = this.measuresArr.includes('cvw') ? 'cvw,desc' : `${this.measuresArr[0]},desc`;
        } else {
          queryParams.s = 'cvw,desc';
        }
      } else if (this.userService.userData.userType === 'cedatopub') {
        if (this.measuresArr.length) {
          queryParams.s = this.measuresArr.includes('cst') ? 'cst,desc' : `${this.measuresArr[0]},desc`;
        } else {
          queryParams.s = 'cst,desc';
        }
      } else if (this.reportType === 'exco-player-release') {
        queryParams.s = 'sop,desc';
      } else {
        queryParams.s = this.measuresArr.length
          ? this.measuresArr.includes('rev')
            ? 'rev,desc'
            : `${this.measuresArr[0]},desc`
          : 'rev,desc';
      }
    }
    return queryParams;
  }

  exportAll() {
    const reportParams: any = this.setReportParams('csv');
    this.isExporting = true;
    this.subscriptions.push(
      this.httpService.post(this.endpointURL + '/getCSVReport', reportParams).subscribe(
        (response: any) => {
          if (response.status && response.status === 'big report') {
            this.isExporting = false;
            this.exportAllByEmail();
            this.sharedService.sendMessage('GRID_DETECT_CHANGES');
          } else {
            this.isExporting = false;
            const blob = new Blob([response.data], { type: 'text/csv; charset=utf-8' });
            saveAs(blob, this.dictionaryService.get('EXPORTED_DATA') + '.csv');
            this.sharedService.sendMessage('GRID_DETECT_CHANGES');
          }
        },
        () => {
          this.isExporting = false;
          this.isError = true;
          this.sharedService.sendMessage('GRID_DETECT_CHANGES');
        }
      )
    );
  }

  exportAllByEmail(shouldClearTimeout: boolean = false) {
    if (shouldClearTimeout) {
      clearTimeout(this.reportTimeout);
    }
    const reportParams: any = this.setReportParams();
    reportParams.email = !_.isUndefined(this.userService.userData.email) ? this.userService.userData.email : '';
    reportParams.limit = -1;
    reportParams.isTimeout = this.isReportTimeout;
    this.subscriptions.push(
      this.route.data.subscribe((data) => {
        reportParams.endpointURL = data.isAdmin ? 'admin_dynamic_reports' : 'dynamic_reports';
      })
    );
    setTimeout(() => {
      this.onReportReportByEmail(reportParams);
    }, 400);
  }

  openTimezonePopup() {
    this.modalsService.showModal({
      component: 'timezone',
      title: this.dictionaryService.get('CHANGE_REPORT_TIME_ZONE'),
    });
  }

  setReportSorting(userAction: boolean = false) {
    let sorting: any;
    let dayHourFetched = '';
    let dayHourSelected = '';

    sorting = _.cloneDeep(this.sorting);
    if (sorting.attrName === undefined) {
      sorting = this.setDefaultSorting();
    } else {
      dayHourFetched = _.without(
        _.map(this.fetchedReportDimensions.split(','), (one: string) => {
          return +one === 9 ? 'dy' : +one === 10 ? 'hr' : false;
        }),
        false
      );
      dayHourSelected = _.without(
        _.map(this.selectedDimensions, (one: any) => {
          return +one.dimension_id === 9 ? 'dy' : +one.dimension_id === 10 ? 'hr' : false;
        }),
        false
      );
      if (
        !_.isEqual(dayHourFetched, dayHourSelected) ||
        !_.isEqual(this.selectedDimensions, this.fetchedReportDimensions.split(','))
      ) {
        if (dayHourSelected.length && !userAction) {
          sorting = this.setDefaultSorting();
        } else if (!this.reportColumnsAlias.includes(sorting.attrName)) {
          sorting = this.setDefaultSorting();
        }
      } else {
        if (!this.reportColumnsAlias.includes(sorting.attrName)) {
          sorting = this.setDefaultSorting();
        }
      }
    }
    return sorting;
  }

  setDefaultSorting() {
    let sorting: any;
    const dayDimensionIndex: number = _.findIndex(this.selectedDimensions, { value: 'dy' });
    const hourDimensionIndex: number = _.findIndex(this.selectedDimensions, { value: 'hr' });

    sorting = {
      sort: 'desc',
    };
    if (hourDimensionIndex !== -1 && dayDimensionIndex !== -1) {
      sorting.attrName = hourDimensionIndex > dayDimensionIndex ? 'dy' : 'hr';
    } else if (hourDimensionIndex !== -1) {
      sorting.attrName = 'hr';
    } else if (dayDimensionIndex !== -1) {
      sorting.attrName = 'dy';
    } else {
      sorting.attrName =
        +this.labsVer === 1
          ? this.measuresArr.length
            ? this.measuresArr.includes('r')
              ? 'r'
              : this.measuresArr[0]
            : 'r'
          : this.reportType === 'content_reports'
          ? this.measuresArr.length
            ? this.measuresArr.includes('cvw')
              ? 'cvw'
              : this.measuresArr[0]
            : 'cvw'
          : this.userService.userData.userType === 'cedatopub'
          ? this.measuresArr.length
            ? this.measuresArr.includes('cst')
              ? 'cst'
              : this.measuresArr[0]
            : 'cst'
          : this.measuresArr.length
          ? this.measuresArr.includes('rev')
            ? 'rev'
            : this.measuresArr[0]
          : 'rev';
    }

    return sorting;
  }

  fillLocalMultifilters() {
    this.availableMultifilters.hr = Array.apply(null, { length: 24 }).map(Number.call, String);
    this.availableMultifilters.dy = this.sharedService.daysList(this.startDate, this.endDate);
    this.availableMultifilters.dt = _.map(this.demandService.getDemandTypes(), (one) => {
      return one.id.toString();
    });
    this.availableMultifilters.st = _.map(this.supplyService.supplyTypes, (one) => {
      return one.id.toString();
    });
    this.availableMultifilters.en = _.map(this.sharedService.envTypes, 'id');
  }

  onShowDemandStatus($event: any = null) {
    const idx: number = _.findIndex(this.columnsSettings, { key: 'demand_name' });

    this.showDemandStatus = $event && idx > -1;

    if (this.isDemandReport) {
      this.queryParams.ds = this.showDemandStatus ? 1 : 0;
    } else {
      delete this.queryParams.ds;
    }

    this.location.go(location.pathname, this.sharedService.stringToQueryParams(this.queryParams));
    this.sharedService.sendMessage('GRID_REDRAW');
  }

  isItDemandReport(): boolean {
    return !!_.find(this.selectedDimensions, { value: 'di' });
  }

  // initial hidecedatox for additional link on mouseover popup
  static isCedatoX(key: string = ''): boolean {
    return ['supply_typex', 'demand_typex'].includes(key);
  }

  onColumnsVisibilityChange($event): void {
    let graphProperties: any;
    let selectedReportColumn: any;
    if (this.labsVer === 1) { return; }

    //updating visible columns list
    let updatedColumns = $event.map((one) => {
      const found = _.find(this.gridService.reportColumns, { actualKey: one.key });
      return !one.key.includes('$$') && one.visible
        ? found && found.reportKey.length !== 2
          ? found.reportKey
          : null
        : null;
    });

    updatedColumns = updatedColumns.filter((one) => one);

    //updating graph keys list
    graphProperties = $event.map((one) => {
      return !one.key.includes('$$') && one.visible && (one.isDemand || one.isSupply)
        ? {
            key: one.key,
            label: one.label,
            decimal: one.decimal,
          }
        : null;
    });

    this.graphProperties = graphProperties.filter((one) => one);
    this.displayGraphControls();
    this.showGraphButtons = true;

    //in case if removed active graph Key
    if (this.graphProperties.length > 0 && !_.find(this.graphProperties, { key: this.graphCurrKey })) {
      this.setGraphKey(this.graphProperties[0].key);

      selectedReportColumn = _.find(this.gridService.reportColumns, { actualKey: this.graphProperties[0].key });
      if (selectedReportColumn && selectedReportColumn.key) { this.queryParams.s = `${selectedReportColumn.key},desc`; }
      this.router.navigate([], { queryParams: this.queryParams }).then(() => {
        return;
      });
    }

    this.graphToggleStatus = this.graphProperties.length > 0;

    //detects is it enough just redraw grid, or necessary get more data from BE
    if (_.difference(updatedColumns, this.measuresArr).length === 0 || this.showPartnerReport) {
      this.sharedService.sendMessage('GRID_REDRAW');
    } else {
      this.getColumns().then(() => {
        this.sharedService.sendMessage('GRID_REDRAW');

        if (this.reportType !== 'exco-player-release') {
          this.buildGraphs();
        }
        this.getReport();
      });
    }
  }

  onReportBreakDownByPartner($event): void {
    const { partnerId, networkId, demandId } = $event;
    const reportParams = this.setReportParams();

    reportParams.partnerNetworkId = networkId;
    reportParams.multifilters = {si: [partnerId]};
    this.subscriptions.push(this.httpService.post('dynamic_reports/getReport', reportParams).subscribe(
      (response: any) => {
        if (!response.data) {
          return;
        }
        const pubReportIndex = this.data.findIndex(row => row.demand_id === demandId);
        const pubReport = this.data[pubReportIndex] || {};
        const newReports = Array.from(response.data, (el) => this.gridService.mergePartnerReports(el, pubReport));

        this.data.splice(pubReportIndex, 1);
        this.data = [...newReports, ...this.data];
        this.showPartnerReport = true;
        this.getColumns().then(() => {
          this.sharedService.sendMessage('GRID_REDRAW');
          this.isLoading = false;
        });
      }
    ));
  }

  //reset definition is it current custom report
  resetCurrentCustomReport() {
    this.theSameCustomReport = this.queryParams.hasOwnProperty('crp');
    if (!this.theSameCustomReport) {
      localStorage.removeItem('customReportHiddenColumns');
    }

    const queryParams: any = _.cloneDeep(this.queryParams);
    delete queryParams.crp;
    const url = this.sharedService.stringToQueryParams(queryParams);
    this.location.go(location.pathname, url);
  }

  onTabSelected($event) {
    if (this.tabsData[$event] && this.tabsData[$event]['key']) {
      this.tabIndexSelected = $event;
      this.onGoButtonClick(false);
    }
  }

  get selectedVersions() {
    return this.selectedItems.map(item => item.s4);
  }

  // On full-screen change event-handling
  @HostListener('document:fullscreenchange', ['$event'])
  @HostListener('document:webkitfullscreenchange', ['$event'])
  onFullScreenChange() {
    this.graphFullScreenState = !this.graphFullScreenState;
  }

  // On resize event-handling
  @HostListener('window:resize', ['$event'])
  onResize($event: any = null) {
    if (!this.sharedService.isMobile() || $event === 'orientationchange' || $event === 'updateGraph') {
      // Show the 'Updating...' animation for the graph
      this.graphs.days.isLoading = true;
      setTimeout(() => {
        this.updateGraphTransform();
      }, this.graphUpdateDelay);
    }
  }

  // On orientation change event
  @HostListener('window:orientationchange', ['$event'])
  onOrientationChange() {
    this.onResize('orientationchange');
  }

  // On document click event-handling
  @HostListener('document:click', ['$event'])
  onDocumentClick($event: any) {
    let clickedOutsideOfMainElement = true;
    let index: number;
    let found = false;
    let foundOverride = false;
    let openedMultifilter: any;
    let clickedDimensionKey: string = null;
    const selectedDimensionsDataOld: Array<any> = _.cloneDeep(this.selectedDimensionsData);
    const path: any =
      $event.path ||
      ($event.composedPath && $event.composedPath($event)) ||
      this.sharedService.composedPath($event.target);

    /*
      Close dimensions menu
    */
    for (const item in path) {
      if (path.hasOwnProperty(item) && path[item].id === 'dimensionsList') {
        this.showDimensionsList = true;
        clickedOutsideOfMainElement = false;
        break;
      }
      if (path.hasOwnProperty(item) && path[item].id === 'addDimensionButton') {
        this.showDimensionsList = !this.showDimensionsList;
        clickedOutsideOfMainElement = false;
        break;
      }
    }
    if (clickedOutsideOfMainElement) {
      this.showDimensionsList = false;
    }

    /*
      Close selected dimensions' filters
    */
    // Check if an element with the class 'filterDimensionButton' was clicked
    index = 0;
    while (!found && index < path.length) {
      found = _.indexOf(path[index].classList, 'filterDimensionButton') > -1;
      if (!found) {
        index++;
      }
    }
    index = 0;
    while (!foundOverride && index < path.length) {
      foundOverride = _.indexOf(path[index].classList, 'multifilterList') > -1;
      if (!foundOverride) {
        index++;
      }
    }
    // If an element with the class 'filterDimensionButton' was clicked - find a parent element with the class 'selectedDimensionsItem'
    if (found || foundOverride) {
      index = 0;
      found = false;
      while (index < path.length && !found) {
        found = _.indexOf(path[index].classList, 'selectedDimensionsItem') > -1;
        if (!found) {
          index++;
        }
      }
    }
    // Get the clicked column's ID (no reason for the next two conditions to be falsy, it's just a fail-safe)
    if (found) {
      index = 0;
      found = false;
      while (index < path.length && !found) {
        if (path[index].attributes !== undefined) {
          if (path[index].attributes['data-key']) {
            found = path[index].attributes['data-key'].value !== undefined;
          }
        }
        found ? (clickedDimensionKey = path[index].attributes['data-key'].value) : index++;
      }
    }
    // For all of the columns - the menu will be opened only if the menu-button for this column was clicked, and the menu is currently closed
    for (let i = 0; i < this.selectedDimensionsData.length; i++) {
      this.selectedDimensionsData[i].filterMenuToggleStatus =
        clickedDimensionKey === this.selectedDimensionsData[i].dimension.value &&
        (!this.selectedDimensionsData[i].filterMenuToggleStatus || foundOverride);
      if (this.selectedDimensionsData[i].filterMenuToggleStatus) {
        openedMultifilter = this.selectedDimensionsData[i].dimension;
      }
    }
    if (!_.isEqual(this.selectedDimensionsData, selectedDimensionsDataOld)) {
      this.multifiltersSearch = '';
      if (openedMultifilter) {
        if (this.availableMultifilters[openedMultifilter.value]) {
          this.updateMultifiltersForDimension(openedMultifilter);
        } else {
          this.multifiltersLoadingState[openedMultifilter.value] = true;
          this.getMultifilters(openedMultifilter);
        }
        this.focusOnOpenedMultifilter();
      }
    }

    /*
      Update the graph
    */
    // If this is the 'large' layout (not relevant for 'small' or 'medium', as in these layouts, the graph has the 'Fullscreen' button option)
    if (this.sharedService.layout === 'large') {
      // Detect if the 'sideMenuButton' was clicked
      found = false;
      index = 0;
      while (!found && index < path.length) {
        found = path[index].id === 'sideMenuButton';
        if (!found) {
          index++;
        }
      }
      // If the 'sideMenuButton' was clicked, call 'onResize' to reshape the graph
      if (found) {
        this.onResize('updateGraph');
      }
    }
  }
}
